import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  ChangeEvent,
} from "react";
import Select from "react-select";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import Container from "../../components/layout/Container/Container";
import { Button, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import PersonalInformation, {
  initialPersonalInfo,
} from "./Helper/ProfileInformation";

import {
  getAquaApplication,
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getBreedSpeciesSpecimensDetails,
  getBreedSpecimenBySpecies,
  getCAVSMaster,
  getPshCavsTestCodeMaster,
  SavAquaDraftApplications,
  saveAquaCancellation,
  saveResultRequest,
  saveAckRequest,
  PremiseCodeDetails,
  getAmendmentHistory,
} from "../../api/apimethods";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { IAquaSamplesAndTests } from "../../typings/models/AquaSamplesAndTests";
import moment from "moment";
import { IAquaClinicalHistoryDisease } from "../../typings/models/AquaClinicalHistoryDisease";
import { IAquaApplicationDetails } from "../../typings/models/AquaApplicationDetails";
import { IChooseApp } from "../../typings/models/ChooseApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { ILabTestDetails } from "../../typings/models/LabTestDetails";
import { notify } from "../../utils";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { helper } from "../../utils/helper";
import { defaultAppContextData } from "../../services/appData";
import {
  IAquaRequest,
  defAQUACancelAppStatus,
} from "../../typings/interfaces/Requests/AquaRequest";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import {
  faCircleExclamation,
  faInfoCircle,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";
import { TypeOfApplicationEnum, ApplicationTypeEnum } from "../../utils/enum";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import { AquaMetaContext } from "../../App";
import { IAquaPreference } from "../../typings/models/AquaPreference";
import { ITestPshCavsCodeMasterModel } from "../../typings/models/PshCavsTestCodeMasterModel";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import FileSaver from "file-saver";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import { ITestResult } from "../../typings/interfaces/Requests/TestResult";
import Loader from "../../components/molecules/Loader";
import { useContextService } from "../../services";
import { IAmendmentHistoryResponse } from "../../typings/interfaces/Responses/LabApplicationsResponse";
import AmendmentGrid from "./AmendmentGrid";
const { message } = notify();
const { btnLoaderHandler, getFilerInfomation, fileToBase64 } = helper();
const stepWizardConfig: IStepwizardProps = {
  currentStep: 2,
  steps: [
    {
      name: "Choose Application",
    },

    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};

enum sampleDetailMandatoryFields {
  purposeOfTest = "purposeOfTest",
  samplingFromDate = "samplingFromDate",
  samplingToDate = "samplingToDate",
  sampledBy = "sampledBy",
  countryOfBirth = "countryOfBirth",
}

enum clinicalHistoryMandatoryFields {
  clinicalHistory = "clinicalHistory",
}

enum SamplesAndTestMandatoryFields {
  sampleMarking = "sampleMarking",
  species = "species",
  specimenDescription = "specimenDescription",
  breed = "breed",
  labAquaTestDetail = "labAquaTestDetail",
}
enum PreferenceMandatoryFields {
  modeOfReceiving = "modeOfReceiving",
}
enum ResultMandatoryFields {
  resultcode = "resultcode",
  testingInstructions = "testingInstructions",
  remarksForThirdParty = "remarksForThirdParty",
}

type RepeatCounts = {
  [sampleIndex: number]: {
    [testIndex: number]: number;
  };
};
const CAVSAquaSamplesAndTests = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const [params, setParams] = useSearchParams();
  const [IsAcknowledgeRequest, setIsAcknowledgeRequest] =
    useState<boolean>(false);
  const [IsAcknowledge, setIsAcknowledge] = useState<boolean>(false);
  const { aquaMeta } = useContext(AquaMetaContext);
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const maxdate = currentDate.toISOString().split("T")[0];
  const maxDateTime = currentDate.toISOString().slice(0, 16);
  const [labtestoptions, setlabtestoptions] = useState<
    ITestPshCavsCodeMasterModel[]
  >([]);
  const testRowId = Number(params.get("rowId") ?? "");

  const [originalSamplesAndTests, setOriginalSamplesAndTests] = useState<
    IAquaSamplesAndTests[]
  >([]);
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [cancelButtonHidden, setCancelButtonHidden] = useState(false);
  const [ResultCodeOptions, setResultCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [countryOptions, setCountryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [RedMessage, setRedMessage] = useState("");
  const [personalInfo, setPersonalInfo] =
    useState<IPersonalInfo>(initialPersonalInfo);
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [isPostMartem, setIsPostMartem] = useState(0);
  const [isThirdPartyLab, setisThirdPartyLab] = useState<string>("");
  const [rejectedTestsMessage, setRejectedTestsMessage] = useState("");
  const [reportgenerated, setreportgenerated] = useState<number>(0);
  const [IsSubmitresultRequest, setIsSubmitresultRequest] =
    useState<boolean>(false);
  const [repeatCounts, setRepeatCounts] = useState<RepeatCounts>({});
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [samplesToBeCollectedOptions, setSamplesToBeCollectedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [diseasePatternOptions, setDiseasePatternOptions] =
    useState<IBioPurposeOfTest[]>();
  const [cancelMessage, setcancelMessage] = useState<string | null>(null);
  const [IsBiosurvillanceUser, setIsBiosurvillanceUser] = useState(false);
  const [validDates, setValidDates] = useState<boolean>(false);
  const [showFarmDetails, setShowFarmDetails] = useState(false);
  const [animalDetails, setShowanimalDetails] = useState(true);
  const [noOrDiseasedOptions, setNoOrDiseasedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [totalNoOfUnitsOptions, setTotalNoOfUnitsOptions] =
    useState<IBioPurposeOfTest[]>();
  const [modeOfPayment, setModeOfPayment] = useState<string>(
    localStorage.getItem("modeOfPayment") || ""
  );
  const [premisesCodeOptions, setpremisesCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [thirdPartyNric, setthirdPartyNric] = useState<string>("");
  const [submittedFeedback, setSubmittedFeedback] = useState<number>(0);
  const [testStatus, setTestStatus] = useState<string>("");
  const [euthanised, setEuthanised] = useState<boolean>(false);
  const [copyCount, setCopyCount] = useState<number>(1);
  const [showPostMortem, setShowPostMortem] = useState(true);
  const [unitSizeOptions, setUnitSizeOptions] = useState<IBioPurposeOfTest[]>();
  const [farmAreaOptions, setFarmAreaOptions] = useState<IBioPurposeOfTest[]>();
  const [ageAffectedOptions, setAgeAffectedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [speciesSelectOptions, setSpeciesSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [labTestID, setlabTestID] = useState<string>("");
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>([]);
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>([]);
  const [specimenOptions, setSpecimenOptions] = useState<ILabSpecimenMaster[]>(
    []
  );
  const [BioSurveillanceValues, setBioSurveillanceValues] = useState<string[]>(
    []
  );
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const [activeTab, setActiveTab] = useState<number>(1);
  const [hasFetchedInitialData, setHasFetchedInitialData] = useState(false);
  const [showGroupAnimals, setShowGroupAnimals] = useState(true);
  const [clinicalHistoryOptions, setClinicalHistoryOptions] =
    useState<IBioPurposeOfTest[]>();
  const [checkpageLoader, setcheckPageLoader] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedTestLaboratory, setSelectedTestLaboratory] =
    useState("All-laboratories");
  const [customerNRIC, setCustomerNRIC] = useState("");
  const [searchInd, setSearchInd] = useState(-1);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [showSearchTestsModal, setShowSearchTestsModal] = useState(false);
  const handleCloseSearchTestsModal = () => setShowSearchTestsModal(false);
  const [showAdditionalContent, setShowAdditionalContent] = useState(false);
  const [showAmendmentHistory, setShowAmendmentHistory] = useState(false);
  const [amendmentHistory, setAmendmentHistory] = useState<
    IAmendmentHistoryResponse[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [testOptions, setTestOptions] = useState<ITestPshCavsCodeMasterModel[]>(
    []
  );
  const [showQuarantineInfo, setShowQuarantineInfo] = useState(false);
  const [selectedTestIds, setSelectedTestIds] = useState<
    (number | undefined)[]
  >([]);
  const [testDescription, setTestDescription] = useState<string>("");
  const [addressType, setAddressType] = useState<string>("");
  const handleShowSearchTestsModal = (index: number) => {
    setSearchInd(index);
    setShowSearchTestsModal(true);
  };

  interface PostMortemConsentForm {
    ID: string;
    postMortemConsentFormName: string;
    postMortemConsentForm: string;
  }
  const fieldOptionPairs = [
    { field: "noOrDisease", option: "noOrDiseasedOptions" },
    { field: "totalNoOfUnits", option: "noOfUnitsOptions" },
    { field: "unitSize", option: "unitSizeOptions" },
    { field: "farmArea", option: "farmAreaOptions" },
    { field: "ageAffected", option: "ageAffectedOptions" },
  ];
  const stripHtmlTags = (str: string) => {
    return str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, "");
  };
  const strippedHtmlTags = (str: string) => {
    return str.replace(/<\/?[^>]+(>|$)/g, "").trim();
  };
  const toggleQuarantineInfo = () => {
    setShowQuarantineInfo((prev) => !prev);
  };
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  const postMartemFields = [
    "resultcode",
    "testingInstructions",
    "remarksForThirdParty",
  ];
  const handleDiseaseSignClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowAdditionalContent(!showAdditionalContent);
  };

  const handleShowAmendmentHistory = async (appNo: string) => {
    if (!appNo) return;

    try {
      const amdresponse = await getAmendmentHistory(appNo);
      setAmendmentHistory(amdresponse);
      setShowAmendmentHistory(true);
      setIsLoading(true);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching amendment history:", error);
    }
  };

  const toggleTestSelection = (
    labCodeMasterID: string | undefined,
    isChecked: boolean
  ) => {
    setTestOptions((prevOptions) =>
      prevOptions.map((test) =>
        test.labCodeMasterID === labCodeMasterID
          ? { ...test, isSelected: isChecked }
          : test
      )
    );

    setSelectedTestIds((prevSelected: any) => {
      if (isChecked) {
        return [...prevSelected, labCodeMasterID as string];
      } else {
        return prevSelected.filter((id: any) => id !== labCodeMasterID);
      }
    });
  };
  const handleSelectedChange =
    (name: string) => (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      } as React.ChangeEvent<HTMLSelectElement>;
      handleAppDetails(event, "string");
    };
  const handleEuthanisedChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const isChecked = event.target.checked;
    setEuthanised(isChecked);
    setSamples((prevState) =>
      prevState.map((item, i) =>
        i === index ? { ...item, euthanised: isChecked } : item
      )
    );
  };

  useEffect(() => {
    btnLoaderHandler(btnNameForLoader ? true : false);
  }, [btnNameForLoader]);
  useEffect(() => {
    if (IsSubmitresultRequest || IsAcknowledge) {
      setActiveTab(4);
    }
  }, [IsSubmitresultRequest, IsAcknowledge]);
  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    fetchTestCodeMaster();
  };
  const fetchLabTestOptions = async () => {
    try {
      const labMastersResponse: any = await getPshCavsTestCodeMaster({
        PurposeCode: "AQU",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });
      const labMastersData = labMastersResponse.data;
      const labTestOptions = labMastersData.cavsLabMasters.map((item: any) => ({
        labGroupId: item.labGroupId,
        title: item.title,
        labGroup: item.labGroup,
      }));

      setlabtestoptions(labTestOptions);
    } catch (error) {}
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch(e as unknown as React.MouseEvent<HTMLButtonElement>);
  };

  const handlepostmartemFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    sampleIndex: number
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const filesArray = Array.from(event.target.files);
      const fileObjects: PostMortemConsentForm[] = await Promise.all(
        filesArray.map(async (file) => {
          const base64 = await fileToBase64(file);
          return {
            ID: "",
            postMortemConsentFormName: file.name,
            postMortemConsentForm: base64,
          };
        })
      );

      const fileNames = filesArray.map((file) => file.name);
      setSamples((prevState) => {
        const updatedSamplesAndTests = [...prevState];
        const existingForms =
          updatedSamplesAndTests[sampleIndex]?.postMortemConsentForms || [];
        const existingFormNames =
          updatedSamplesAndTests[sampleIndex]?.postMortemConsentFormName || "";
        updatedSamplesAndTests[sampleIndex] = {
          ...updatedSamplesAndTests[sampleIndex],
          postMortemConsentForms: [
            ...(Array.isArray(existingForms) ? existingForms : []),
            ...fileObjects,
          ],
          postMortemConsentFormName: existingFormNames
            ? `${existingFormNames}, ${fileNames.join(", ")}`
            : fileNames.join(", "),
        };

        return updatedSamplesAndTests;
      });
    }
  };
  const handledremoveFile = (
    fileName: string,
    sampleIndex: number,
    fileIndex: number
  ) => {
    setSamples((prevState) => {
      return prevState.map((sample, index) => {
        if (index !== sampleIndex) {
          return sample;
        }

        if (typeof sample.postMortemConsentFormName !== "string") {
          return sample;
        }

        const fileNamesArray = sample.postMortemConsentFormName.split(", ");

        if (fileIndex < 0 || fileIndex >= fileNamesArray.length) {
          return sample;
        }

        const updatedFileNamesArray = fileNamesArray.filter(
          (_, i) => i !== fileIndex
        );

        const updatedPostMortemConsentForms = Array.isArray(
          sample.postMortemConsentForms
        )
          ? sample.postMortemConsentForms.filter((_, i) => i !== fileIndex)
          : [];

        const updatedSample = {
          ...sample,
          postMortemConsentForms: updatedPostMortemConsentForms,
          postMortemConsentFormName: updatedFileNamesArray.join(", "),
        };

        return updatedSample;
      });
    });
  };
  const handledFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      let filesArray = Array.from(event.target.files);
      let documentsArray: { ID: string; Name: string; Attachment: string }[] =
        [];

      for (let file of filesArray) {
        const base64String = await fileToBase64(file);
        if (base64String.length) {
          documentsArray.push({
            ID: "",
            Name: file.name,
            Attachment: base64String,
          });
        }
      }

      if (documentsArray.length) {
        setMyPreference((prevState) => {
          return {
            ...prevState,
            supportDocuments: [
              ...(prevState.supportDocuments || []),
              ...documentsArray,
            ],
            supportDocumentName: [
              ...(prevState.supportDocumentName
                ? prevState.supportDocumentName.split(", ")
                : []),
              ...documentsArray.map((doc) => doc.Name),
            ].join(", "),
          } as typeof myPreference;
        });
      }
    }
  };

  const handleRemoveFile = (fileName: string) => {
    setMyPreference((prevState) => {
      const fileIndex = prevState.supportDocumentName
        ?.split(", ")
        .indexOf(fileName);
      if (fileIndex === -1) return prevState;
      const updatedSupportDocuments = prevState.supportDocuments?.filter(
        (_, index) => index !== fileIndex
      );
      const updatedSupportDocumentNames = prevState.supportDocumentName
        ?.split(", ")
        .filter((_, index) => index !== fileIndex)
        .join(", ");
      return {
        ...prevState,
        supportDocuments: updatedSupportDocuments,
        supportDocumentName: updatedSupportDocumentNames,
      };
    });
  };
  useEffect(() => {
    fetchLabTestOptions();
  }, []);

  const fetchTestCodeMaster = async () => {
    try {
      handleLoader(true, "submit-reqq");
      const response: any = await getPshCavsTestCodeMaster({
        PurposeCode: "AQU",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });

      if (response.data && response.data.cavs) {
        const selectedLabTitle = selectedTestLaboratory;
        let searchString: string = testDescription || "";
        const cavsData = response.data.cavs;

        const formatDescription = (description: string) => {
          return description.replace(/<i>/g, "<em>").replace(/<\/i>/g, "</em>");
        };
        if (selectedLabTitle === "All-laboratories") {
          const filteredData = cavsData.filter((item: any) =>
            item.description
              ? stripHtmlTags(item.description)
                  .toLowerCase()
                  .includes(searchString.toLowerCase())
              : false
          );

          const transformedData = filteredData.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
            testMethodSOPDescription: item.testMethodSOPDescription,
          }));
          setTestOptions(transformedData);
        } else {
          const labGroupId = labtestoptions.find(
            (item: any) => item.labGroup === selectedLabTitle
          )?.labGroupId;

          if (!labGroupId) {
            console.error(
              "Lab Master ID not found for the selected laboratory labGroup:",
              selectedLabTitle
            );
            return;
          }

          const customFilter = cavsData.filter(
            (x: any) =>
              x.labGroupId === labGroupId &&
              (x.name
                ? stripHtmlTags(x.name)
                    .toLowerCase()
                    .includes(searchString.toLowerCase())
                : false)
          );

          const transformedData = customFilter.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
            testMethodSOPDescription: item.testMethodSOPDescription,
          }));
          setTestOptions(transformedData);
        }
      } else {
        const errorMessage = "Failed to retrieve the CAVS data from the API";

        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    } finally {
      handleLoader(false, "submit-reqq");
    }
  };
  const sampleSchema: IAquaSamplesAndTests = {
    id: Date.now(),
    sampleMarking: "",
    species: "",
    breed: "",
    specimenDescription: "",
    noOnPremises: 0,
    noInGroup: 0,
    noOfSamples: 1,
    antibioticSensitivityTestRequired: false,
    noSick: 0,
    noDead: 0,
    noAtRisk: 0,
    groupID: "",
    penNo: "",
    owner: "",
    microchipNo: "",
    gender: "",
    sterilized: 0,
    longitude: "",
    latitude: "",
    nameofAnimal: "",
    years: 0,
    months: 0,
    weeks: 0,
    dateofBirth: null,
    countryofResidence: "",
    labAquaTestDetail: [],
    remarks: "",
    animalStatus: null,
    euthanisedDate: null,
    euthanised: false,
    saveRemains: null,
    methodofEuthanised: "",
  };
  const defaultTestResult: ITestResult = {
    resultcode: "",
    Readings: 0,
    Readings2: 0,
    Symbol1: 0,
    Symbol2: 0,
    Positive: "",
    Negative: "",
    Indefinite: "",
    ResultRemarks: "",
    units: "",
    report: "",
    Parasitology: "",
    Microbiology: "",
    Histopathology: "",
    ourreference: "",
    finalDiagnosis: "",
    resultcodeErrMsg: "",
    testingInstructions: "",
    remarksForThirdParty: "",
  };
  const mergeWithDefaults = (result: any) => ({
    ...defaultTestResult,
    ...result,
  });
  const [samples, setSamples] = useState<IAquaSamplesAndTests[]>([
    ...[sampleSchema],
  ]);
  const [cancelComments, setCancelComments] = useState<string>("");
  const [cancelCommentsErrMsg, setCancelCommentsErrMsg] = useState<string>("");
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [actionType, setActionType] = useState<string>("");
  const [applicationNum, setApplicationNum] = useState<string>("");
  const [amendCase, setAmendCase] = useState<string>("");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<string>();
  const [customerName, setCustomerName] = useState<string>("");
  const [salutation, setSalutation] = useState<string>("");
  const tempClicnicHistory: IAquaClinicalHistoryDisease = {
    clinicalHistory: 0,
    diseaseStartedOn: null,
    diseasePattern: 0,
    totalNoOnPermises: 0,
    noOrDisease: 0,
    noDeadDaily: 0,
    totalNoDead: 0,
    farmArea: 0,
    totalNoOfUnits: 0,
    noOfUnitsOptions: 0,
    unitSize: 0,
    noAffected: 0,
    ageAffected: 0,
    sizeAffected: 0,
    otherSpeciesOrBreedAff: "",
    clinicalSignAndRemarks: "",
    noOrDiseasedOptions: 0,
    farmAreaOptions: 0,
    unitSizeOptions: 0,
    ageAffectedOptions: 0,
    ago: 0,
    yearsmonth: 0,
    vaccinationHistory: "",
    dateExportedDate: null,
    inQuarantine: false,
    importLicenseNo: "",
    toBeExported: false,
    exportercountryOfDestination: "",
  };

  const [isVaccinationHistoryExpanded, setIsVaccinationHistoryExpanded] =
    useState(false);

  const toggleVaccinationHistory = () => {
    setIsVaccinationHistoryExpanded((prev) => !prev);
  };
  const [clinicalHistory, setClinicalHistory] =
    useState<IAquaClinicalHistoryDisease>(tempClicnicHistory);
  const [originalclinicalHistory, setoriginalClinicalHistory] =
    useState<IAquaClinicalHistoryDisease>(tempClicnicHistory);
  const appDetails: IAquaApplicationDetails = {
    purposeOfTest: 0,
    crossReference: "",
    otherPurposeOfTest: "",
    samplesCollectedOrSubmitted: "Tobesubmitted", // Yet to create in CRM
    courierName: "", // Yet to create in CRM
    courierTrackingNo: "",
    samplingFromDate: null,
    samplingToDate: null,
    referringVeterinarian: "",
    sampledBy: "",
    countryOfBirth: "",
    countryOfDestination: "",
    farmCode: "",
    specialFarmCode: "",
    dateOfImport: null,
    dateToBeExported: null,
    locationName: "",
    longitude: "",
    latitude: "",
    addressType: "",
    postalCode: "",
    streetName: "",
    blockHouseNo: "",
    level: "",
    unitNo: "",
    buildingName: "",
    cityName: "",
    state: "",
    country: "",
    history_Remarks: "",
    euthanised: false,
    euthanisedDate: null,
    methodofEuthanised: "",
    saveRemains: null,
    remarks: "",
    bioSurveillanceProgram: "",
  };
  const [applicationDetails, setApplicationDetails] =
    useState<IAquaApplicationDetails>(appDetails);
  const [originalSampleDetails, setOriginalSampleDetails] =
    useState<IAquaApplicationDetails>(appDetails);
  useEffect(() => {
    getMaster();
  }, []);

  const preferenceSchema: IAquaPreference = {
    specialInstructions: "",
    antimicrobialSusceptibilityTestRequired: false,
    remarks: "",
    supportDocuments: [],
    supportDocumentName: "",
    modeOfReceiving: 0,
    customAddress: "",
    hardcopy: "",
    acknowledge: false,
  };
  const prevModeOfPaymentRef = useRef(modeOfPayment);
  useEffect(() => {
    if (modeOfPayment === "Biosurveillance") {
      setApplicationDetails((prevDetails) => ({
        ...prevDetails,
        purposeOfTest: 1,
      }));
    } else if (prevModeOfPaymentRef.current === "Biosurveillance") {
      setApplicationDetails((prevDetails) => ({
        ...prevDetails,
        purposeOfTest: 0,
      }));
    }

    prevModeOfPaymentRef.current = modeOfPayment;
  }, [modeOfPayment]);
  const reportTypeNames: { [key: number]: string } = {
    1: "Casesheet",
    2: "Laboratory Report",
    3: "Acknowledgment Slip",
    4: "Sample Label",
  };
  const [reports, setReports] = useState<
    {
      reportName: string;
      reportData: string;
      reportType: number;
      reportID: string;
      applicationId: string;
      isReportGenerated: any;
    }[]
  >([]);
  const renderReportType = (type: number) => {
    return reportTypeNames[type] || "Laboratory Report";
  };

  const [myPreference, setMyPreference] =
    useState<IAquaPreference>(preferenceSchema);
  const [originalPreference, setOriginalPreference] =
    useState<IAquaPreference>(preferenceSchema);
  const handleSamplesCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;
    setSamples((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabAquaTestDetails = sample.labAquaTestDetail.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  noOfSamples: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labAquaTestDetail: updatedLabAquaTestDetails,
          };
        }
        return sample;
      });
    });
  };
  const handleAddTestResult = (sampleIndex: number, testLabTestID: string) => {
    const newResult = { ...defaultTestResult };
    setSamples((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabAquaTestDetails = sample.labAquaTestDetail.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const updatedLabAquaTestResult = [
                ...(test.labAquaTestResult || []),
                newResult,
              ];

              return {
                ...test,
                labAquaTestResult: updatedLabAquaTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labAquaTestDetail.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labAquaTestDetail: updatedLabAquaTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };

  const handleRepeatCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setRepeatCounts((prev) => ({
      ...prev,
      [sampleIndex]: {
        ...(prev[sampleIndex] || {}),
        [testIndex]: validatedCount,
      },
    }));

    setSamples((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabAquaTestDetails = sample.labAquaTestDetail.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  noOfTestsRequired: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labAquaTestDetail: updatedLabAquaTestDetails,
          };
        }
        return sample;
      });
    });
  };
  const validateSamplesAndTests = (
    samplesAndTests: any[],
    customerNRIC: string
  ) => {
    let isValidSampleAndTests = true;
    let missingFields: string[] = [];

    const validatedSamples = samplesAndTests.map((item: any) => {
      const filteredTests =
        item.labAquaTestDetail?.filter((test: any) => {
          const isValidTest =
            test.isThirdPartyLab === 1 &&
            test.thirdPartyNric === customerNRIC &&
            test.rowId === testRowId &&
            (test.testStatus === null || test.testStatus !== 8);
          return isValidTest;
        }) || [];

      filteredTests.forEach((test: any) => {
        const isPostMartem = test.isPostMartem === 1;

        const fieldsToValidate = isPostMartem
          ? postMartemFields
          : Object.values(ResultMandatoryFields);

        if (test.labAquaTestResult && test.labAquaTestResult.length > 0) {
          test.labAquaTestResult = test.labAquaTestResult.map(
            (result: any, resultIndex: number) => {
              let isValidResult = true;

              fieldsToValidate.forEach((field) => {
                const fieldValue = result[field];

                if (
                  fieldValue === undefined ||
                  fieldValue === null ||
                  fieldValue === ""
                ) {
                  isValidSampleAndTests = false;
                  isValidResult = false;
                  missingFields.push(field);

                  result = {
                    ...result,
                    [`${field}ErrMsg`]: `Please fill ${field}.`,
                  };
                } else {
                  result = {
                    ...result,
                    [`${field}ErrMsg`]: "",
                  };
                }
              });

              return result;
            }
          );
        }
      });

      return item;
    });

    return { isValidSampleAndTests, validatedSamples, missingFields };
  };
  const handledSaveResultClick = async () => {
    try {
      handleLoader(true, "submit-req");

      const { isValidSampleAndTests, validatedSamples, missingFields } =
        validateSamplesAndTests(samples, customerNRIC);

      if (!isValidSampleAndTests) {
        setSamples(validatedSamples);
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "");
        return;
      }
      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samples.flatMap((sample) =>
          sample.labAquaTestDetail
            .filter((test) => {
              const isValidTest =
                test.isThirdPartyLab === 1 &&
                test.thirdPartyNric === customerNRIC &&
                test.rowId === testRowId &&
                (test.testStatus === null || test.testStatus !== 8);

              return test.testDescription !== "" && isValidTest;
            })
            .flatMap((test) =>
              (test.labAquaTestResult ?? []).map((result, resultIndex) => ({
                labTestID: test.labTestID,
                testDescription: stripHtmlTags(test.testDescription),
                ResultDocuments: test.ResultDocuments ?? [],
                ResultDocumentName: test.ResultDocumentName ?? "",
                isAdditionalResult: resultIndex === 0 ? 0 : 1,
                ...mergeWithDefaults(result),
              }))
            )
        ),
      };

      const response = await saveResultRequest(dataToSubmit);

      if (response?.status === 200) {
        message(NotifyType.Success, "Results Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const handleACKResultClick = async () => {
    try {
      handleLoader(true, "submit-req");
      const newArray = samples.map((sample: any) => {
        sample.labAquaTestDetail.forEach((test: any) => {
          delete test.labAquaTestResult;
        });
        return sample;
      });
      setSamples(newArray);
      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samples.flatMap((sample) =>
          sample.labAquaTestDetail
            .filter(
              (test) =>
                test.testDescription !== "" &&
                test.isThirdPartyLab === 1 &&
                test.rowId === testRowId &&
                test.thirdPartyNric === customerNRIC &&
                test.testStatus !== 8
            )
            .map((test) => ({
              labTestID: test.labTestID,
              testDescription: test.testDescription,
              laboratory: test.laboratory,
              TestStatus: 7,
            }))
        ),
      };
      if (dataToSubmit.labResultRequests.length === 0) {
        message(NotifyType.Warning, "No tests available for submission.");
        return;
      }

      const response = await saveAckRequest(dataToSubmit);
      if (response?.status === 200) {
        message(NotifyType.Success, "Request Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("type", "submitresult");
        window.location.href = currentUrl.toString();
      } else {
        message(NotifyType.Error, "Issue with the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };
  const fetchData = async (addressType: string) => {
    try {
      if (!postalCode.postalCode || addressType !== "Local") {
        return;
      }
      const encodedPostalCode = encodeURIComponent(postalCode.postalCode);
      const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${encodedPostalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;
      const response = await fetch(apiUrl);
      if (!response.ok) {
        console.error("Error:", response);
        return;
      }
      const data = await response.json();
      if (data.found > 0) {
        const result = data.results[0];
        setApplicationDetails((prevDetails) => ({
          ...prevDetails,
          streetName: result.ROAD_NAME,
          blockHouseNo: result.BLK_NO,
          buildingName: result.BUILDING,
        }));
      } else {
        setApplicationDetails((prevDetails) => ({
          ...prevDetails,
          streetName: "",
          blockHouseNo: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setApplicationDetails((prevDetails) => ({
        ...prevDetails,
        streetName: "",
        blockHouseNo: "",
      }));
    }
  };

  const handleAddTests = () => {
    const testsToAdd = testOptions.filter(
      (test) =>
        test?.labCodeMasterID &&
        selectedTestIds.includes(test.labCodeMasterID as any)
    );

    setTestOptions((prevOptions) =>
      prevOptions.filter(
        (test) => !selectedTestIds.includes(test.labCodeMasterID as any)
      )
    );
    setSelectedTestIds([]);

    setSamples((prevSamples: any) => {
      return prevSamples.map((prevSample: any, index: number) => {
        if (index === searchInd) {
          const currentTestDetails = prevSample.labAquaTestDetail || [];

          const addedTests = currentTestDetails.map((detail: any) =>
            strippedHtmlTags(detail.testDescription)
          );

          testsToAdd.forEach((test) => {
            const strippedTestDescription = strippedHtmlTags(test.description);
            if (!addedTests.includes(strippedTestDescription)) {
              currentTestDetails.push({
                testDescription: test.description.trim(),
                laboratory: selectedTestLaboratory,
                noOfTestsRequired: 1,
                noOfSamples: 1,
                testMethodSOPDescription: test.testMethodSOPDescription,
              });
            }
          });

          return {
            ...prevSample,
            labAquaTestDetail: currentTestDetails,
          };
        } else {
          return prevSample;
        }
      });
    });
  };
  const handleRemoveTest = (
    labDetails: any,
    description: string,
    ind: number
  ) => {
    let removeTheLabID = labDetails.filter(
      (x: ILabTestDetails) => x.testDescription != description
    );
    const newArray = samples.map((item: IAquaSamplesAndTests, i) => {
      if (ind === i) {
        return {
          ...item,
          "labAquaTestDetail": removeTheLabID,
        };
      } else {
        return item;
      }
    });
    setSamples(newArray);
  };
  useEffect(() => {
    if (speciesOptions) {
      const speciesOpts = speciesOptions.map((species) => ({
        label: species.speciesName,
        value: species.speciesName,
      }));
      setSpeciesSelectOptions(speciesOpts);
    }
  }, [speciesOptions]);

  const handleSelectChange =
    (index: number, name: string) =>
    async (selectedOption: IReactSelectOption | null) => {
      setSamples((prevSamples) => {
        const updatedSamples = [...prevSamples];
        const updatedSample = { ...updatedSamples[index] };

        if (name === "species") {
          updatedSample.species = selectedOption ? selectedOption.value : "";
          updatedSample.breed = "";
          updatedSample.breedErrMsg = "";
          updatedSample.specimenDescription = "";
          updatedSample.specimenDescriptionErrMsg = "";
          updatedSample.otherSpecies = "";
          updatedSample.otherBreed = "";
          updatedSample.otherSpecimenDescription = "";
          updatedSample.breedOptions = [];
          updatedSample.specimenOptions = [];
          updatedSamples[index] = updatedSample;
          if (selectedOption) {
            fetchBreedAndSpecimenOptions(index, selectedOption.value);
          }
        } else if (
          name === "breed" ||
          name === "specimenDescription" ||
          name === "countryofResidence"
        ) {
          updatedSample[name] = selectedOption ? selectedOption.value : "";
        }

        updatedSamples[index] = updatedSample;
        return updatedSamples;
      });
    };

  const fetchBreedAndSpecimenOptions = async (
    index: number,
    species: string
  ) => {
    const breedSpecimensResponse = await getBreedSpecimenBySpecies(species);
    if (breedSpecimensResponse.status === 200) {
      const { labBreed, labSpecimen } = breedSpecimensResponse.data;
      setSamples((prevSamples) => {
        const updatedSamples = [...prevSamples];
        const updatedSample = { ...updatedSamples[index] };

        updatedSample.breedOptions =
          labBreed?.map((breed: any) => ({
            value: breed.breedName,
            label: breed.breedName,
          })) || [];

        updatedSample.specimenOptions =
          labSpecimen?.map((specimen: any) => ({
            value: specimen.labSpecimenDescription,
            label: specimen.labSpecimenDescription,
          })) || [];

        updatedSamples[index] = updatedSample;
        return updatedSamples;
      });
    }
  };

  const handledSelectChange =
    (index: number, name: string, testIndex: string, resultIndex: number) =>
    (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      };
      handledSamplesAndTestsChange(
        index,
        "string",
        testIndex,
        resultIndex
      )(event as any);
    };

  const handleDownload = (fileName: string, reportData: string, index: number, totalReports: number,  applicationNum: string) => {
    try {
      const decodedData = atob(reportData);
      const byteCharacters = Array.from(decodedData).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteCharacters);

      const blob = new Blob([byteArray], { type: "application/pdf" });

      FileSaver.saveAs(blob, fileName);

    // ✅ Redirect only if this is the last record
    if (index === totalReports - 1) {
      setTimeout(() => {
        window.location.href = `/eservices/rating-feedback?an=${encodeURIComponent(applicationNum)}`;
      }, 800);
    }
      //window.location.href = `/eservices/rating-feedback?an=${applicationNum}`;
    } catch (error) {
      console.error(error);
      message(NotifyType.Info, "Error downloading the file");
    }
  };
  
  const calculateAge = (dateofBirth: string) => {
    const now = moment();
    const birthDate = moment(dateofBirth, "YYYY-MM-DD");

    const years = now.diff(birthDate, "years");
    birthDate.add(years, "years");

    const months = now.diff(birthDate, "months");
    birthDate.add(months, "months");

    const weeks = now.diff(birthDate, "weeks");

    return { years, months, weeks };
  };
  const validateForm = (e: React.FormEvent) => {
    e.preventDefault();
    let isValidAppDetils = true;
    let overAllValidFlag = true;
    let personalInfostorage: IPersonalInfo = { ...initialPersonalInfo };
    try {
      const storedProfileInfo = localStorage.getItem("profile-info");
      if (storedProfileInfo) {
        personalInfostorage = JSON.parse(storedProfileInfo);
      }
    } catch (error) {
      console.error("Error parsing profile-info from localStorage:", error);
    }

    if (!validDates) {
      overAllValidFlag = false;
      message(NotifyType.Error, "Please enter valid sampling date fields.");
    }
    if (!sampleDetailMandatoryFields || !SamplesAndTestMandatoryFields) {
      console.error("Mandatory fields configuration is missing.");
      return;
    }
    let applicationDetailsManFields = Object.values(
      sampleDetailMandatoryFields
    );
    let tempApplicationDetails: any = applicationDetails;
    applicationDetailsManFields.forEach((x: any) => {
      let temp = tempApplicationDetails[x];
      if (typeof temp == "number") {
        if (!temp) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });

    if (applicationDetails?.purposeOfTest === 1) {
      if (!applicationDetails?.bioSurveillanceProgram?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg:
            "Please select a Biosurveillance Program.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg: "",
        };
      }
    }

    setApplicationDetails(tempApplicationDetails);
    if (!isValidAppDetils) {
      overAllValidFlag = false;
    }

    let isValidClinicalHis = true;
    let clinicalHistoryManFields = Object.values(
      clinicalHistoryMandatoryFields
    );
    let tempClicnicalHistory: any = clinicalHistory;

    // Validation for mandatory fields in clinical history
    clinicalHistoryManFields.forEach((x: any) => {
      let temp = tempClicnicalHistory[x];
      if (typeof temp === "number") {
        if (!temp) {
          isValidClinicalHis = false;
          tempClicnicalHistory = {
            ...tempClicnicalHistory,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempClicnicalHistory = {
            ...tempClicnicalHistory,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidClinicalHis = false;
          tempClicnicalHistory = {
            ...tempClicnicalHistory,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempClicnicalHistory = {
            ...tempClicnicalHistory,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });

    fieldOptionPairs.forEach(({ field, option }) => {
      if (tempClicnicalHistory[field] && !tempClicnicalHistory[option]) {
        isValidClinicalHis = false;
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          [`${option}ErrMsg`]: `Please select an option for ${field}.`,
        };
      } else if (tempClicnicalHistory[option]) {
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          [`${option}ErrMsg`]: ``,
        };
      }
    });
    if (applicationDetails?.purposeOfTest === 4) {
      if (!clinicalHistory?.dateExportedDate) {
        isValidAppDetils = false;
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          dateExportedDateErrMsg: "Please select Date to be exported.",
        };
      } else {
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          dateExportedDateErrMsg: "",
        };
      }

      if (!clinicalHistory?.exportercountryOfDestination?.length) {
        isValidAppDetils = false;
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          exportercountryOfDestinationErrMsg:
            "Please select Exporter Country of Destination.",
        };
      } else {
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          exportercountryOfDestinationErrMsg: "",
        };
      }
    } else {
      tempClicnicalHistory = {
        ...tempClicnicalHistory,
        exportercountryOfDestinationErrMsg: "",
        dateExportedDateErrMsg: "",
      };
    }

    if (applicationDetails?.purposeOfTest === 5) {
      if (!applicationDetails?.dateOfImport) {
        isValidAppDetils = false;
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          dateImportDateErrMsg: "Please select Date of import.",
        };
      } else {
        tempClicnicalHistory = {
          ...tempClicnicalHistory,
          dateImportDateErrMsg: "",
        };
      }
    } else {
      tempClicnicalHistory = {
        ...tempClicnicalHistory,
        dateImportDateErrMsg: "",
      };
    }

    setClinicalHistory(tempClicnicalHistory);
    if (!isValidClinicalHis) {
      overAllValidFlag = false;
    }

    /* Mandatory check for samples and tests */
    let isValidSampleAndTests = true;
    let manFieldsSampleAndTests = Object.values(SamplesAndTestMandatoryFields);
    const sampleMarkingsAll = samples
      .map((s: any) => s.sampleMarking?.trim())
      .filter(Boolean);
    const duplicates = sampleMarkingsAll.filter(
      (mark, idx, arr) =>
        arr.indexOf(mark) !== idx && arr.lastIndexOf(mark) === idx
    );
    const newArray = samples.map((item: any) => {
      manFieldsSampleAndTests.forEach((x: any) => {
        let temp = item[x];
        if (typeof temp == "number") {
          if (!temp) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        } else {
          if (!temp?.length) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        }
      });
      const trimmedMark = item.sampleMarking?.trim();
      if (!trimmedMark) {
        isValidSampleAndTests = false;
        item = { ...item, sampleMarkingErrMsg: "Please fill Sampling Marking" };
      } else if (duplicates.includes(trimmedMark)) {
        isValidSampleAndTests = false;
        item = {
          ...item,
          sampleMarkingErrMsg:
            "Sample Marking must be unique across all samples.",
        };
      } else {
        item = { ...item, sampleMarkingErrMsg: "" };
      }
      item.labAquaTestDetail.forEach((testDetail: any) => {
        const isPostMortemTest =
          testDetail.testMethodSOPDescription?.trim().toLowerCase() ===
          "post-mortem";

        if (isPostMortemTest) {
          if (
            !item.postMortemConsentFormName ||
            item.postMortemConsentFormName.length === 0
          ) {
            isValidSampleAndTests = false;
            item = {
              ...item,
              postMortemConsentFormNameErrMsg:
                "Please fill Post-Mortem Consent Form.",
            };
          } else {
            item = { ...item, postMortemConsentFormNameErrMsg: "" };
          }

          if (!item.saveRemains) {
            isValidSampleAndTests = false;
            item = {
              ...item,
              saveRemainsErrMsg:
                "Please select Save remains for Burial/Cremation.",
            };
          } else {
            item = { ...item, saveRemainsErrMsg: "" };
          }
        }
      });
      return item;
    });
    setSamples(newArray);

    if (!isValidSampleAndTests) overAllValidFlag = false;
    let isValidPreferences = true;
    let preferenceFields = Object.values(PreferenceMandatoryFields);
    let tempPreferences: any = myPreference;

    preferenceFields.forEach((x: any) => {
      let temp = tempPreferences[x];
      if (typeof temp === "number") {
        if (!temp) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });
    if (!myPreference?.modeOfReceiving) {
      isValidPreferences = false;
      tempPreferences = {
        ...tempPreferences,
        modeOfReceivingErrMsg: "Please select Mode of Receiving.",
      };
    } else {
      tempPreferences = { ...tempPreferences, modeOfReceivingErrMsg: "" };

      if (myPreference.modeOfReceiving === 1) {
        if (!myPreference?.mailingAddress) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "Please select the mailing address.",
          };
        } else if (
          myPreference.mailingAddress === 3 &&
          !myPreference?.customAddress?.length
        ) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            customAddressErrMsg: "Please enter the custom address.",
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "",
            customAddressErrMsg: "",
          };
        }

        if (!myPreference?.acknowledge) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            acknowledgeErrMsg: "You must acknowledge before proceeding.",
          };
        } else {
          tempPreferences = { ...tempPreferences, acknowledgeErrMsg: "" };
        }
      }
    }
    setMyPreference(tempPreferences);

    if (personalInfostorage) {
      if (!personalInfostorage?.address?.streetName?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address street name fields."
        );
      }
      if (!personalInfostorage?.address?.postalCode?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address postal code fields."
        );
      }

      if (!personalInfostorage?.contact?.salutation) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Salutation.");
      }
      if (!personalInfostorage?.contact?.email) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Email.");
      }
    }

    if (!isValidPreferences) overAllValidFlag = false;

    if (overAllValidFlag) {
      handleNextClick();
    } else {
      message(NotifyType.Error, "Please fill the mandatory fields.");
    }
  };
  const [postalCode, setpostalCode] = useState({
    postalCode: "",
    streetName: "",
    blockHouseNo: "",
    CityName: "",
    state: "",
    unitNo: "",
  });
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#e9ecef" : provided.backgroundColor,
      pointerEvents: state.isDisabled ? "none" : "auto",
      opacity: state.isDisabled ? 1 : 1,
      fontSize: "13px",
      fontWeight: state.isDisabled ? "900" : "900",
      borderRadius: "var(--bs-border-radius)",
      zIndex: state.isFocused ? 1 : 0,
      color: state.isDisabled ? "#6c757d" : provided.color,
      borderColor: state.isDisabled ? "#ced4da" : provided.borderColor,
    }),
    singleValue: (provided: any, state: any) => ({
      ...provided,
      color: state.isDisabled ? "#6c757d" : provided.color,
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 1002,
    }),
  };
  const customedStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#e9ecef" : provided.backgroundColor,
      pointerEvents: state.isDisabled ? "none" : "auto",
      opacity: 1,

      fontSize: "13px",
      fontWeight: "900",
      borderRadius: "var(--bs-border-radius)",
      zIndex: state.isFocused ? 1 : 0,
      padding: "7px",
      minHeight: "25px",
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 1002,
    }),
  };
  const handledSamplesAndTestsChange =
    (
      altIndex: number,
      type: string,
      testLabTestID: string,
      resultIndex: number
    ) =>
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >
    ) => {
      let newValue: boolean | number | string | undefined;
      if (type === "decimal") {
        newValue = Math.max(0, parseFloat(e.target.value));
      } else if (type === "number") {
        newValue = Math.max(0, parseInt(e.target.value));
      } else if (type === "date") {
        newValue = moment(e.target.value, "YYYY-MM-DD").toISOString();
      } else {
        newValue = e.target.value;
      }

      setSamples((prevSamples) => {
        const updatedSamples = prevSamples.map((item) => {
          const updatedLabAquaTestDetails = item.labAquaTestDetail.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedLabAquaTestResult = (
                  test.labAquaTestResult && test.labAquaTestResult.length > 0
                    ? test.labAquaTestResult
                    : [defaultTestResult]
                ).map((result, k) => {
                  if (k === resultIndex) {
                    return {
                      ...result,
                      [e.target.name]: newValue,
                    };
                  } else {
                    return result;
                  }
                });

                return {
                  ...test,
                  labAquaTestResult: updatedLabAquaTestResult,
                };
              } else {
                return test;
              }
            }
          );

          return {
            ...item,
            labAquaTestDetail: updatedLabAquaTestDetails,
          };
        });

        return updatedSamples;
      });
    };

  const handleFormChange =
    (index: number, type: string) =>
    (
      e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
      let newValue: boolean | number | string | undefined;

      if (type === "number") {
        newValue = Math.max(0, parseInt(e.target.value));
      } else if (type === "date") {
        newValue = moment(e.target.value, "YYYY-MM-DD").toISOString();
      } else if (type === "radio") {
        newValue = e.target.value;
      } else if (type === "checkbox") {
        newValue = (e as ChangeEvent<HTMLInputElement>).target.checked;
      } else {
        newValue = e.target.value;
      }

      const newArray = samples.map((item: IAquaSamplesAndTests, i) => {
        if (index === i) {
          const updatedItem = {
            ...item,
            [e.target.name.replace(`-${index}`, "")]: newValue,
          };

          if (e.target.name === "dateofBirth") {
            const age = calculateAge(e.target.value);
            updatedItem.years = age.years;
            updatedItem.months = age.months;
            updatedItem.weeks = age.weeks;
          }
          return updatedItem;
        } else {
          return item;
        }
      });

      setSamples(newArray);
    };
  const handleCopyButtonClick = (index: number) => {
    handleCopySample(index, copyCount || 1);
  };

  const handleCopyInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyCount(Number(event.target.value));
  };

  const handleClinicalDetails = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any = e.target.value;
    if (type === "number") {
      value = Math.max(0, parseInt(value));
    } else if (type === "checkbox") {
      value = (e.target as HTMLInputElement).checked;
    } else if (type === "date") {
      value = moment(value, "YYYY-MM-DD").toISOString();
    }
    setClinicalHistory((prevState) => {
      return { ...prevState, [name]: value } as IAquaClinicalHistoryDisease;
    });
  };
  const handleAppDetails = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any = e.target.value;

    if (type === "radio") {
      if ((e.target as HTMLInputElement).checked) {
        setAddressType(value);
        if (name === "addressType" && value === "Local") {
          setApplicationDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "Singapore",
          }));
          return;
        } else if (name === "addressType" && value === "Foreign") {
          setApplicationDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "",
            postalCode: "",
            blockHouseNo: "",
            streetName: "",
            level: "",
            unitNo: "",
            buildingName: "",
            cityName: "",
            state: "",
          }));
          return;
        }
      }
    } else if (type === "checkbox") {
      value = (e.target as HTMLInputElement).checked;
    } else {
      value = e.target.value;

      if (type === "number") {
        value = Math.max(0, parseInt(value));
      } else if (type === "date") {
        value = moment(value, "YYYY-MM-DD").toISOString();
      }
    }

    setApplicationDetails((prevState) => {
      const newDetails = {
        ...prevState,
        [name]: value,
      } as IAquaApplicationDetails;

      let validDates = true;

      if (newDetails.samplingFromDate && newDetails.samplingToDate) {
        const fromDate = moment(newDetails.samplingFromDate);
        const toDate = moment(newDetails.samplingToDate);

        if (toDate.isBefore(fromDate)) {
          newDetails.samplingToDateErrMsg =
            "Sampling To Date must be after Sampling From Date";
          validDates = false;
        } else {
          newDetails.samplingToDateErrMsg = undefined;
        }
        if (fromDate.isAfter(toDate)) {
          newDetails.samplingFromDateErrMsg =
            "Sampling From Date must be before Sampling To Date";
          validDates = false;
        } else {
          newDetails.samplingFromDateErrMsg = undefined;
        }
      }

      setValidDates(validDates);
      setRedMessage("");
      if (applicationDetails?.purposeOfTestErrMsg) {
        applicationDetails.purposeOfTestErrMsg = "";
      }
      return newDetails;
    });
  };

  const handleMyPreference = async (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any;
    let obj: any;

    if (type === "number") {
      value = parseInt(e.target.value);
      obj = { [name]: value };
    } else if (type === "date") {
      value = moment(e.target.value, "YYYY-MM-DD").toISOString();
      obj = { [name]: value };
    } else if (type === "file") {
      let file = (e?.target as HTMLInputElement)?.files;
      if (file?.length) {
        const getBase64 = await fileToBase64(file[0]);
        if (getBase64.length) {
          obj = {
            [name]: getBase64,
            [`${name}Name`]: file[0]?.name,
          };
        }
      }
    } else if (type === "string") {
      value = e.target.value;
      obj = { [name]: value };
    } else if (type === "checkbox") {
      value = (e.target as HTMLInputElement).checked;
      obj = { [name]: value };
    }

    setMyPreference((prevState) => {
      return { ...prevState, ...obj } as IAquaPreference;
    });
  };

  const getMaster = async () => {
    try {
      setPageLoader(true);
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || null;
      let UEN = userInfo?.user?.uen || null;
      let role = userInfo?.user?.role || "";
      setCustomerNRIC(role === "CorpPass" ? UEN : NRIC);
      const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
      const response = await getCAVSMaster();
      if (response.status == 200) {
        let cavsMaster = response.data;
        let bioMaster = cavsMaster.bioMasters;
        if (bioMaster) {
          let purposeTest = bioMaster.testPurpose;
          let values = Object.values(purposeTest);
          let purposeTestArr = Object.keys(purposeTest).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          if (bioMaster.bioSurveillances) {
            const fetchedBioSurveillanceValues = bioMaster.bioSurveillances.map(
              (service: any) => service.uen
            );
            setBioSurveillanceValues(fetchedBioSurveillanceValues);

            const isBioUser =
              Array.isArray(fetchedBioSurveillanceValues) &&
              fetchedBioSurveillanceValues.includes(customerIdentifier);
            setIsBiosurvillanceUser(isBioUser);
          }
          setPurposeOfTestOptions(purposeTestArr);
          const resultCode = bioMaster.resultCodeMaster;
          if (resultCode) {
            const resultCodeArr = resultCode.map((result: any) => ({
              label: result.resultCodeName,
              value: result.resultCodeId,
            }));
            setResultCodeOptions(resultCodeArr);
          }
          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
            const premisesMaster = bioMaster.premisesMaster;
            if (premisesMaster) {
              const premisesCodeOptions = premisesMaster.map((result: any) => ({
                label: result.premisesCode,
                value: result.premisesCode,
              }));

              setpremisesCodeOptions(premisesCodeOptions);
            }
          }
        }

        const countryRes = await getBioCountryOfDestination();
        setCountryOfDestinationOptions(countryRes?.data || []);

        const conutryRes = await getBioCountryOfOrigin();
        setCountryOfOriginOptions(conutryRes?.data || []);

        const countryOptions = (conutryRes?.data || []).map((country) => ({
          value: country.name,
          label: country.name,
        }));
        setCountryOptions(countryOptions);
        let samplesToBeCollected = response?.data?.bioMasters?.samplesCollSub;
        if (samplesToBeCollected) {
          let values: number[] = Object.values(samplesToBeCollected);
          let samplesToBeCollectedArr: IBioPurposeOfTest[] = Object.keys(
            samplesToBeCollected
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setSamplesToBeCollectedOptions(samplesToBeCollectedArr);
        }

        let diseasePattern = response?.data?.bioMasters?.diseasePattern;
        if (diseasePattern) {
          let values: number[] = Object.values(diseasePattern);
          let diseasePatternArr: IBioPurposeOfTest[] = Object.keys(
            diseasePattern
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setDiseasePatternOptions(diseasePatternArr);
        }

        let noOrDiseased = response?.data?.bioMasters?.noOrDisease;
        if (noOrDiseased) {
          let values: number[] = Object.values(noOrDiseased);
          let noOrDiseasedArr: IBioPurposeOfTest[] = Object.keys(
            noOrDiseased
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setNoOrDiseasedOptions(noOrDiseasedArr);
        }

        let totalNoOfUnits = response?.data?.bioMasters?.totalNoOfUnits;
        if (totalNoOfUnits) {
          let values: number[] = Object.values(totalNoOfUnits);
          let totalNoOfUnitsArr: IBioPurposeOfTest[] = Object.keys(
            totalNoOfUnits
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setTotalNoOfUnitsOptions(totalNoOfUnitsArr);
        }

        let unitSize = response?.data?.bioMasters?.unitSize;
        if (unitSize) {
          let values: number[] = Object.values(unitSize);
          let unitSizeArr: IBioPurposeOfTest[] = Object.keys(unitSize).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setUnitSizeOptions(unitSizeArr);
        }

        let farmArea = response?.data?.bioMasters?.farmArea;
        if (farmArea) {
          let values: number[] = Object.values(farmArea);
          let farmAreaArr: IBioPurposeOfTest[] = Object.keys(farmArea).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setFarmAreaOptions(farmAreaArr);
        }

        let ageAffected = response?.data?.bioMasters?.ageAffected;
        if (ageAffected) {
          let values: number[] = Object.values(ageAffected);
          let ageAffectedArr: IBioPurposeOfTest[] = Object.keys(
            ageAffected
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setAgeAffectedOptions(ageAffectedArr);
        }

        let clinicalHistory = response?.data?.bioMasters?.clinicalHistory;
        if (clinicalHistory) {
          let values: number[] = Object.values(clinicalHistory);
          let clinicalHistoryArr: IBioPurposeOfTest[] = Object.keys(
            clinicalHistory
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setClinicalHistoryOptions(clinicalHistoryArr);
        }
      }

      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("AQU");

      if (breedspeciesresponse.status == 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }
      }

      const meta: IAquaRequest = aquaMeta.aquaMeta;
      if (Object.keys(meta)?.length) {
        setHasFetchedInitialData(true);
        setSamples(meta.labAQUASampleTestDetails);
        setApplicationDetails(meta.labAQUAApplicationDetails);
        setClinicalHistory(
          meta?.labAQUAApplicationDetails?.clinicalHistoryDisease as any
        );
        setMyPreference(meta?.labAQUAPreference);
        const fromDate = meta.labAQUAApplicationDetails.samplingFromDate;
        const toDate = meta.labAQUAApplicationDetails.samplingToDate;
        if (moment(fromDate).isValid() && moment(toDate).isValid()) {
          setValidDates(true);
        } else {
          setValidDates(false);
        }
      }

      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };

  const generateRejectedTestsMessage = (samplesAndTests: any[]) => {
    let message = "Please be noted that the Test: ";
    let rejectedTests: string[] = [];

    samplesAndTests.forEach((sample: any, sampleIndex: number) => {
      const sampleMarking = sample.sampleMarking;
      sample.labAquaTestDetail.forEach((test: any) => {
        if (test.testStatus === 6) {
          rejectedTests.push(
            `${test.testDescription} under Sample ${
              sampleIndex + 1
            } (${sampleMarking})`
          );
        }
      });
    });

    if (rejectedTests.length > 0) {
      message += rejectedTests.join(", ") + " is/are Rejected.";
    } else {
      message = "";
    }

    return message;
  };

  useEffect(() => {
    /* Check for query string */
    async function checkQueryString() {
      setcheckPageLoader(true);
      try {
        const applicationNum: string | null = params.get("an");
        const getUserInfo = localStorage.getItem("app-data");
        const userInfo = JSON.parse(getUserInfo || "");
        const isMetadata = localStorage.getItem("ismetadata");
        let NRIC = userInfo?.user?.idNo || "";
        let isNricRequired = 1;
        const actionType: string | null = params.get("type");
        setActionType(actionType || "");
        setApplicationNum(applicationNum || "");

        if (
          actionType === TypeOfApplicationEnum.submitresult ||
          actionType === TypeOfApplicationEnum.Acknowledge
        ) {
          isNricRequired = 0;
        }

        if (applicationNum && actionType) {
          const getAqua = await getAquaApplication(
            applicationNum,
            NRIC,
            isNricRequired
          );
          if (getAqua.status === 200) {
            setShowPlaceholder(false);
            let result: IAquaRequest = getAqua.data.result;

            if (result?.labAQUAApplicationDetails) {
              const fromDate =
                result.labAQUAApplicationDetails.samplingFromDate;
              const toDate = result.labAQUAApplicationDetails.samplingToDate;

              if (moment(fromDate).isValid() && moment(toDate).isValid()) {
                setValidDates(true);
              } else {
                setValidDates(false);
              }
            }
            const feedback = result?.submittedFeedback || 0;
            const reportgenerated = result?.isReportGenerated || 0;
            const reports = Array.isArray(result?.labReportDetails)
              ? result.labReportDetails
              : [];
            setReports(reports);
            setSubmittedFeedback(feedback);
            const personalInfoDetails = result?.labAQUAPersonalInfoDetails;
            if (isMetadata !== "1") {
              setPersonalInfo(personalInfoDetails);
              setreportgenerated(reportgenerated);
              setClinicalHistory(
                result?.labAQUAApplicationDetails?.clinicalHistoryDisease ||
                  tempClicnicHistory
              );
              setoriginalClinicalHistory(
                result?.labAQUAApplicationDetails?.clinicalHistoryDisease ||
                  tempClicnicHistory
              );
              setApplicationDetails(result?.labAQUAApplicationDetails);
              setOriginalSampleDetails(result?.labAQUAApplicationDetails);
              setMyPreference(result?.labAQUAPreference);
              setOriginalPreference(result?.labAQUAPreference);
              if (result?.labAQUAPersonalInfoDetails?.contact) {
                setCustomerName(result.labAQUAPersonalInfoDetails.customerName);
                setSalutation(
                  result.labAQUAPersonalInfoDetails.contact.salutation
                );
              }
            }
            if (result?.labAQUASampleTestDetails?.length > 0) {
              localStorage.setItem(
                "choose-app",
                JSON.stringify(result.labAQUAChooseApplDetails)
              );

              const actionedStatus = result?.actionStatus;
              if (actionedStatus) {
                localStorage.setItem("psh-app-status", actionedStatus);
                localStorage.setItem("psh-app-applicationNum", applicationNum);
              }

              if (
                actionType == TypeOfApplicationEnum.amendment &&
                result?.actionStatus
              ) {
                let amendCase = "";
                if (result.actionStatus === "Pending Sample(s)") {
                  amendCase = "CASE3";
                } else {
                  amendCase = "CASE4";
                }

                setAmendCase(amendCase);
              } else if (actionType == TypeOfApplicationEnum.cancel) {
                setIsCancelRequest(true);
              } else if (actionType === TypeOfApplicationEnum.submitresult) {
                setIsSubmitresultRequest(true);
              } else if (actionType === TypeOfApplicationEnum.Acknowledge) {
                setIsAcknowledge(true);
              } else if (actionType == TypeOfApplicationEnum.acknowledgement) {
                setIsAcknowledgeRequest(true);
              }

              const appNo = params.get("an") ?? "";
              if (
                appNo &&
                result?.labAQUAChooseApplDetails?.applicationType ==
                  ApplicationTypeEnum.amendment
              ) {
                handleShowAmendmentHistory(appNo);
                setShowAmendmentHistory(true);
              }

              let samplesAndTests = result.labAQUASampleTestDetails.map(
                (sample, index) => {
                  const postmartem = sample.labAquaTestDetail.map(
                    (obj: any) => ({
                      isPostMartem: obj.isPostMartem,
                      labTestID: obj.labTestID,
                      testStatus: obj.testStatus,
                      rowId: obj.rowId,
                      noOfTestsRequired: obj.noOfTestsRequired,
                      noOfSamples: obj.noOfSamples,
                      isThirdPartyLab: obj.isThirdPartyLab,
                      thirdPartyNric: obj.thirdPartyNric,
                      testMethodSOPDescription: obj.testMethodSOPDescription,
                      disableDelete: true,
                      testDescription: obj.description || obj.testDescription,
                      labAquaTestResult: [defaultTestResult],
                    })
                  );

                  if (postmartem.length > 0) {
                    setIsPostMartem(postmartem[0].isPostMartem);
                    setlabTestID(postmartem[0].labTestID);
                    setTestStatus(postmartem[0].testStatus);
                    setisThirdPartyLab(postmartem[0].isThirdPartyLab);
                    setthirdPartyNric(postmartem[0].thirdPartyNric);
                  }
                  return {
                    ...sample,
                    id: sample.id || index + 1,
                    sampleCaseRowId: sample.rowId,
                    disableDelete: true,
                    labAquaTestDetail: postmartem,
                  };
                }
              );

              if (isMetadata !== "1") {
                setSamples(samplesAndTests);
                setOriginalSamplesAndTests(samplesAndTests);
              }
              samplesAndTests.forEach(async (sample, index) => {
                if (sample.species) {
                  await fetchBreedAndSpecimenOptions(index, sample.species);
                }
              });

              await Promise.all(samplesAndTests);
              setRejectedTestsMessage(
                generateRejectedTestsMessage(samplesAndTests)
              );
            }
          }
        }
      } catch (error) {
        console.error(ErrMsg.InternalServerErrMsg, error);
        message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
      } finally {
        setcheckPageLoader(false);
        localStorage.removeItem("ismetadata");
      }
    }

    if (!hasFetchedInitialData) {
      checkQueryString();
      setHasFetchedInitialData(true);
    }
  }, [clinicalHistoryOptions, hasFetchedInitialData]);
  useEffect(() => {
    if (applicationDetails?.farmCode) {
      const fetchPremiseDetails = async () => {
        try {
          const response = await PremiseCodeDetails(
            applicationDetails?.farmCode
          );

          setApplicationDetails((prevDetails) => ({
            ...prevDetails,
            postalCode: response.data.postalCode || "",
            streetName: response.data.streetRoadName || "",
            blockHouseNo: response.data.blockHouseNumber || "",
            country: response.data.country || "",
            buildingName: response.data.buildingName || "",
            locationName: response.data.premisesName || "",
            level: response.data.floorNumber || "",
            unitNo: response.data.unitNumber || "",
            cityName: response.data.districtCity || "",
            state: response.data.stateProvince || "",
            addressType:
              response.data.country === "Singapore" ? "Local" : "Foreign",
          }));
        } catch (error) {
          console.error("Failed to fetch premise details", error);
        }
      };

      fetchPremiseDetails();
    } else {
      setApplicationDetails((prevDetails) => ({
        ...prevDetails,
        postalCode: "",
        streetName: "",
        blockHouseNo: "",
        country: "",
        buildingName: "",
        locationName: "",
      }));
    }
  }, [applicationDetails?.farmCode]);

  const handleAddSample = () => {
    setSamples((prevSamples) => {
      const newSample = { ...sampleSchema, id: Date.now() };
      return [...prevSamples, newSample];
    });
  };

  const handleCopySample = (sampleInd: number, times: number) => {
    const sample = samples[sampleInd];

    setSamples((prevSamples) => {
      const newSamples = Array.from({ length: times }, () => {
        const newSample = {
          ...sample,
          id: Date.now() + Math.random(),
          disableDelete: false,
          labAquaTestDetail: sample?.labAquaTestDetail?.map((obj: any) => ({
            ...obj,
            disableDelete: false,
          })),
        };
        if (newSample.hasOwnProperty("rowId")) {
          delete newSample.rowId;
        }

        return newSample;
      });

      return [...prevSamples, ...newSamples];
    });
  };

  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };
  const handleToggleAnimalDetails = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    setShowanimalDetails((prevShowAnimalDetails) => !prevShowAnimalDetails);
  };

  const handleDeleteSample = (sampleId: number | undefined) => {
    setSamples((samples) => {
      if (samples.length > 1) {
        return samples.filter((sample) => sample.id !== sampleId);
      }
      return samples;
    });
  };

  const handleDeleteTestResult = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamples((prevSamples) => {
      const updatedSamples = prevSamples.map((item) => {
        const updatedLabAquaTestDetails = item.labAquaTestDetail.map((test) => {
          if (test.labTestID === testLabTestID) {
            const updatedLabAquaTestResult = test.labAquaTestResult
              ? test.labAquaTestResult.filter((_, k) => k !== resultIndex)
              : [];

            if (updatedLabAquaTestResult.length === 0) {
              updatedLabAquaTestResult.push(defaultTestResult);
            }

            return {
              ...test,
              labAquaTestResult: updatedLabAquaTestResult,
            };
          } else {
            return test;
          }
        });

        return {
          ...item,
          labAquaTestDetail: updatedLabAquaTestDetails,
        };
      });

      return updatedSamples;
    });
  };
  const handleSaveDraft = async () => {
    delete applicationDetails?.purposeOfTestErrMsg;
    delete applicationDetails?.samplesCollectedOrSubmittedErrMsg;
    delete applicationDetails?.sampledByErrMsg;
    delete applicationDetails?.samplingFromDateErrMsg;
    delete applicationDetails?.samplingToDateErrMsg;
    delete clinicalHistory?.clinicalHistoryErrMsg;
    delete clinicalHistory?.noOrDiseasedOptionsErrMsg;
    delete clinicalHistory?.farmAreaOptionsErrMsg;
    delete clinicalHistory?.unitSizeOptionsErrMsg;
    delete clinicalHistory?.noOfUnitsOptionsErrMsg;
    delete clinicalHistory?.ageAffectedOptionsErrMsg;

    try {
      handleLoader(true, "submit-req");
      const hasEmptyTests = samples.some(
        (sample) =>
          !sample.labAquaTestDetail || sample.labAquaTestDetail.length === 0
      );

      if (hasEmptyTests) {
        message(NotifyType.Error, "Please add Test Information.");
        handleLoader(false, "submit-req");
        return;
      }
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "AQU",
        typeOfService: "CAVS Laboratory Services",
        applicationType: 0,
      };

      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );
      const filerInfo: IFilerInformation | null = getFilerInfomation();
      let appDetails = { ...applicationDetails };
      appDetails["clinicalHistoryDisease"] = clinicalHistory;
      const meta: IAquaRequest = {
        labAQUAPersonalInfoDetails: personalInfo,
        labAQUAChooseApplDetails: chooseAppMeta,
        labAQUAApplicationDetails: appDetails,
        applicationNumber: applicationNum,
        labAQUASampleTestDetails: samples.map((sample) => {
          return {
            ...sample,
            labAquaTestDetail: sample.labAquaTestDetail.map((test: any) => ({
              ...test,
              testDescription: stripHtmlTags(test.testDescription),
            })),
          };
        }),
        labAQUAPreference: myPreference,
        labAQUAFilerInfoDetails: filerInfo || tempFilerInfo,
      };

      if (actionType === TypeOfApplicationEnum.submit) {
        delete meta.applicationNumber;
      }
      const response1 = await SavAquaDraftApplications(meta);
      if (response1.status == 200) {
        const acknowledgmentNumber = response1.data?.match(
          /CAVS_AQUAApplicationNumber: (\w+)/
        )?.[1];
        setApplicationNum(acknowledgmentNumber || "");
        if (actionType === TypeOfApplicationEnum.submit) {
          setActionType("Draft");
        }
        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );
        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );

        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const cancelRequest = async () => {
    delete applicationDetails?.purposeOfTestErrMsg;
    delete applicationDetails?.otherPurposeOfTestErrMsg;
    delete applicationDetails?.samplesCollectedOrSubmittedErrMsg;
    delete applicationDetails?.sampledByErrMsg;
    delete applicationDetails?.samplingFromDateErrMsg;
    delete applicationDetails?.samplingToDateErrMsg;
    delete clinicalHistory?.clinicalHistoryErrMsg;
    delete clinicalHistory?.noOrDiseasedOptionsErrMsg;
    delete clinicalHistory?.farmAreaOptionsErrMsg;
    delete clinicalHistory?.unitSizeOptionsErrMsg;
    delete clinicalHistory?.noOfUnitsOptionsErrMsg;
    delete clinicalHistory?.ageAffectedOptionsErrMsg;

    let appDetails = { ...applicationDetails };
    appDetails["clinicalHistoryDisease"] = clinicalHistory;
    samples.forEach((x) => {
      delete x.id;
      delete x?.sampleMarkingErrMsg;
      delete x?.speciesErrMsg;
      delete x?.breedErrMsg;
      delete x?.specimenDescriptionErrMsg;
      delete x?.labAquaTestDetailErrMsg;
      delete x?.postMortemConsentFormNameErrMsg;
      delete x?.saveRemainsErrMsg;
      delete x?.disableDelete;
      x?.labAquaTestDetail?.forEach((element) => {
        delete element?.disableDelete;
      });
    });

    try {
      setCancelCommentsErrMsg("");
      if (cancelComments) {
        handleLoader(true, "cancel-request-btn");
        let chooseAppMeta: IChooseApp = {
          typeOfApplication: "AQU",
          typeOfService: "CAVS Laboratory Services",
          applicationType: 0,
        };

        let personalInfo: IPersonalInfo = JSON.parse(
          localStorage.getItem("profile-info") || ""
        );
        const applicationNum: string = params.get("an") ?? "";
        const filerInfo: IFilerInformation | null = getFilerInfomation();
        const meta: IAquaRequest = {
          labAQUAPersonalInfoDetails: personalInfo,
          labAQUAChooseApplDetails: chooseAppMeta,
          labAQUAApplicationDetails: appDetails,
          labAQUASampleTestDetails: samples,
          applicationNumber: applicationNum,
          labAQUAApplicationStatus: defAQUACancelAppStatus,
          labAQUAPreference: myPreference,
          labAQUAFilerInfoDetails: filerInfo || tempFilerInfo,
          reasonForCancellation: cancelComments,
        };

        let response1 = await saveAquaCancellation(meta);
        if (response1.status === 200) {
          const acknowledgmentNumberMatch = response1.data?.match(
            /"CAVS_AQUACancelApplicationNumber":"(\w+)"/
          );

          const acknowledgmentNumber = acknowledgmentNumberMatch
            ? acknowledgmentNumberMatch[1]
            : undefined;

          message(
            NotifyType.Success,
            `Cancellation Request Submitted Successfully. Acknowledgment Number: ${acknowledgmentNumber}`
          );
          setcancelMessage(
            acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
          );

          localStorage.removeItem("choose-app");
          setCancelButtonHidden(true);
          setTimeout(() => {
            navigate("/lab-dashboard", { state: { acknowledgmentNumber } });
          }, 3000);
        } else {
          message(NotifyType.Error, "Issue on the request submission.");
        }
      } else {
        setCancelCommentsErrMsg("Please fill Cancellation Comments");
        message(NotifyType.Error, "Please fill the mandatory fields.");
      }
      handleLoader(false, "cancel-request-btn");
    } catch (ex) {
      console.error(ex);
      handleLoader(false, "cancel-request-btn");
    }
  };

  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };

  const handlePreviousClick = () => {
    if (IsAcknowledgeRequest || isCancelRequest || amendCase) {
      navigate("/lab-dashboard");
    } else {
      navigate("/choose-application");
    }
  };
  const handledPreviousClick = () => {
    navigate("/labresults-dashboard");
  };
  const handledFiledChange = async (
    sampleIndex: number,
    testLabTestID: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      const files = Array.from(event.target.files);
      const base64Files = await Promise.all(
        files.map((file) => fileToBase64(file))
      );

      const newResultDocuments = base64Files.filter(
        (base64) => base64.length > 0
      );
      const newResultDocumentNames = files.map((file) => file.name);

      setSamples((prevState) => {
        const updatedSamples = prevState.map((sample, sIndex) => {
          const updatedLabAquaTestDetail = sample.labAquaTestDetail.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedResultDocuments = [
                  ...(test.ResultDocuments || []),
                  ...newResultDocuments,
                ];
                const updatedResultDocumentNames = [
                  ...(test.ResultDocumentName
                    ? test.ResultDocumentName.split(", ")
                    : []),
                  ...newResultDocumentNames,
                ];

                return {
                  ...test,
                  ResultDocuments: updatedResultDocuments,
                  ResultDocumentName: updatedResultDocumentNames.join(", "),
                };
              }
              return test;
            }
          );

          return {
            ...sample,
            labAquaTestDetail: updatedLabAquaTestDetail,
          };
        });

        return updatedSamples;
      });
    }
  };

  function getModifiedPreference(
    original: IAquaPreference,
    current: IAquaPreference
  ): IAquaPreference | undefined {
    const modified: Partial<IAquaPreference> = {};

    for (const key in current) {
      if (
        JSON.stringify(original[key as keyof IAquaPreference]) !==
        JSON.stringify(current[key as keyof IAquaPreference])
      ) {
        modified[key as keyof IAquaPreference] =
          current[key as keyof IAquaPreference];
      }
    }
    if (Object.keys(modified).length === 0) {
      return undefined;
    }
    return modified as IAquaPreference;
  }
  function getModifiedValues<T>(original: T, current: T): Partial<T> {
    const modified: Partial<T> = {};
    for (const key in current) {
      if (current[key] !== original[key]) {
        modified[key] = current[key];
      }
    }
    return modified;
  }
  function getModifiedSamplesAndTests(
    original: IAquaSamplesAndTests[],
    current: IAquaSamplesAndTests[]
  ) {
    return current
      .map((currentItem, index) => {
        const originalItem = original[index];
        const modifiedItem: any = {};
        if (currentItem.sampleCaseRowId !== originalItem?.sampleCaseRowId) {
          modifiedItem.sampleCaseRowId = currentItem.sampleCaseRowId;
        }
        (Object.keys(currentItem) as (keyof IAquaSamplesAndTests)[]).forEach(
          (key) => {
            const currentValue = currentItem[key];
            const originalValue = originalItem ? originalItem[key] : undefined;
            if (currentValue !== originalValue) {
              modifiedItem[key] = currentValue;
            }
          }
        );
        return Object.keys(modifiedItem).length > 0 ? modifiedItem : null;
      })
      .filter((item) => item !== null);
  }
  const getAquaRequestSchema = (): IAquaRequest => {
    delete applicationDetails?.purposeOfTestErrMsg;
    delete applicationDetails?.otherPurposeOfTestErrMsg;
    delete applicationDetails?.samplesCollectedOrSubmittedErrMsg;
    delete applicationDetails?.sampledByErrMsg;
    delete applicationDetails?.samplingFromDateErrMsg;
    delete applicationDetails?.samplingToDateErrMsg;
    delete clinicalHistory?.clinicalHistoryErrMsg;
    delete clinicalHistory?.noOrDiseasedOptionsErrMsg;
    delete clinicalHistory?.farmAreaOptionsErrMsg;
    delete clinicalHistory?.unitSizeOptionsErrMsg;
    delete clinicalHistory?.noOfUnitsOptionsErrMsg;
    delete clinicalHistory?.ageAffectedOptionsErrMsg;
    let appDetails = applicationDetails;
    appDetails["clinicalHistoryDisease"] = clinicalHistory;
    let sampleRowId = 1;
    const updatedSamples = samples.map((sample) => {
      let testRowId = 1;
      const updatedSample = {
        ...sample,
        rowId: sampleRowId,
        sampleRowId: sampleRowId++,
        labAquaTestDetail: sample.labAquaTestDetail?.map((test) => ({
          ...test,
          rowId: testRowId,
          testRowId: testRowId++,
        })),
      };

      delete updatedSample.id;
      delete updatedSample.sampleMarkingErrMsg;
      delete updatedSample.speciesErrMsg;
      delete updatedSample.breedErrMsg;
      delete updatedSample.specimenDescriptionErrMsg;
      delete updatedSample.labAquaTestDetailErrMsg;
      delete updatedSample.postMortemConsentFormNameErrMsg;
      delete updatedSample.saveRemainsErrMsg;
      delete updatedSample.disableDelete;
      updatedSample.labAquaTestDetail?.forEach((test) => {
        delete test.disableDelete;
      });

      return updatedSample;
    });

    let chooseAppMeta: IChooseApp = {
      typeOfService: "CAVS Laboratory Services",
      typeOfApplication: "AQU",
      applicationType: 0,
    };

    const modifiedFromSampleDetails = getModifiedValues(
      originalSampleDetails,
      applicationDetails
    );
    const modifiedFromClinicalHistory = getModifiedValues(
      originalclinicalHistory,
      clinicalHistory
    );
    const modifiedBioDetails = {
      ...modifiedFromSampleDetails,
      ...(Object.keys(modifiedFromClinicalHistory).length > 0
        ? { clinicalHistoryDisease: modifiedFromClinicalHistory }
        : {}),
    };

    const modifiedSamplesAndTests = getModifiedSamplesAndTests(
      originalSamplesAndTests,
      samples
    );
    const modifiedPreference = getModifiedPreference(
      originalPreference,
      myPreference
    );
    const filerInfo: IFilerInformation | null = getFilerInfomation();
    let personalInfo: IPersonalInfo = JSON.parse(
      localStorage.getItem("profile-info") || ""
    );
    let meta: IAquaRequest = {
      labAQUAChooseApplDetails: chooseAppMeta,
      labAQUAPersonalInfoDetails: personalInfo,
      labAQUAApplicationDetails: appDetails,
      labApplicationchangedDetails:
        modifiedBioDetails as IAquaApplicationDetails,
      labchangedSampleTestDetails: modifiedSamplesAndTests,
      labChangedPreference: modifiedPreference,
      labAQUASampleTestDetails: updatedSamples,
      labAQUAPreference: myPreference,
      actionStatus: actionType || "",
      labAQUAFilerInfoDetails: filerInfo || tempFilerInfo,
    };
    if (meta.actionStatus !== TypeOfApplicationEnum.submit) {
      meta.applicationNumber = applicationNum || "";
    }

    return meta;
  };

  const storeInContext = () => {
    let meta: IAquaRequest = getAquaRequestSchema();
    aquaMeta.updateAquaMeta(meta);
  };
  const handledCopyButtonClick = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamples((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabAquaTestDetails = sample.labAquaTestDetail.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const labAquaTestResult = Array.isArray(test.labAquaTestResult)
                ? test.labAquaTestResult
                : [];
              const valueToCopy = labAquaTestResult[resultIndex]
                ? { ...labAquaTestResult[resultIndex] }
                : defaultTestResult;

              const updatedLabAquaTestResult = [
                ...labAquaTestResult,
                valueToCopy,
              ];

              return {
                ...test,
                labAquaTestResult: updatedLabAquaTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labAquaTestDetail.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labAquaTestDetail: updatedLabAquaTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };

  const handleNextClick = () => {
    handleLoader(true, "next-click");
    storeInContext();
    setSamples([sampleSchema]);
    localStorage.removeItem("ismetadata");
    navigate("/aqua-review");
    handleLoader(false, "next-click");
  };

  let bannerName = "Application for Laboratory Testing";
  if (isCancelRequest) {
    bannerName = "Submission of Cancellation Request";
  } else if (amendCase) {
    bannerName = "Submission of Amendment Request";
  } else if (IsAcknowledge) {
    bannerName = "Acknowledge Test";
  } else if (IsSubmitresultRequest) {
    bannerName = "Submission of Test Result";
  }
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        {pageLoader || checkpageLoader ? (
          <Loader />
        ) : (
          <div className="row setup-content" id="step-1">
            <div className="col-md-12">
              <div className="tab-wizard-content">
                {acknowledgmentMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Application has been successfully Saved as Draft.
                        Service Acknowledgement Number: &nbsp;
                        {acknowledgmentMessage ? acknowledgmentMessage : ""}
                      </p>
                    </div>
                  </div>
                )}

                {RedMessage && (
                  <div className="info-content">
                    <div className="att">
                      <br />
                      <div className="text-danger">
                        <center>{RedMessage}</center>
                      </div>
                    </div>
                  </div>
                )}
                {cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Cancellation Request Submitted Successfully.
                        Service Acknowledgement Number: &nbsp;
                        {cancelMessage ? cancelMessage : ""}
                      </p>
                    </div>
                  </div>
                )}
                {applicationNum && !cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h2>
                        <center>Application Number: {applicationNum}</center>
                      </h2>
                    </div>
                  </div>
                )}
                {!IsSubmitresultRequest && !IsAcknowledge ? (
                  <PersonalInformation
                    profileInfo={personalInfo}
                    onModeOfPaymentChange={setModeOfPayment}
                  />
                ) : null}

                {IsAcknowledgeRequest ? (
                  <div className="personal-info">
                    <div className="clonable-block" data-toggle="cloner">
                      <div className="clonable" data-clone-number="1">
                        <div className="info-heading">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th className="grid-header">Report Name</th>
                                <th className="grid-header">Report Type</th>
                                <th className="grid-header">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reports
                                .filter((report) => {
                                  const actionedStatus =
                                    localStorage.getItem("psh-app-status");
                                  if (report.reportData === null) return false;
                                  if (report.reportType === 5) {
                                    return (
                                      actionedStatus !== "Pending Sample(s)" &&
                                      actionedStatus !== "Sample(s) Received"
                                    );
                                  }
                                  return report.reportType === 3;
                                })
                                .map((report, index) => (
                                  <tr key={report.reportName}>
                                    <td>
                                      <center>
                                        <h6>{report.reportName}</h6>
                                      </center>
                                    </td>
                                    <td>
                                      <h6>
                                        {renderReportType(report.reportType)}
                                      </h6>
                                    </td>
                                    <td>
                                      <button
                                        className="ACKFile"
                                        onClick={() =>
                                          handleDownload(
                                            report.reportName,
                                            report.reportData,
                                            index,
                                            reports.length,
                                            applicationNum 
                                          )
                                        }
                                      >
                                        Download
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="info-content">
                  <div className="attt">
                    <h2>
                      <center>
                        <h2>Purpose Code: AQU</h2>
                      </center>
                    </h2>
                  </div>
                </div>

                <Tabs
                  className="samples-and-tests-cavs"
                  activeKey={activeTab.toString()}
                  onSelect={(k: string | null) => {
                    if (k) {
                      setActiveTab(parseInt(k));
                    }
                  }}
                  id="controlled-tab-example"
                >
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={1} title="Sample Details">
                      <div className="personal-info">
                        <div className="info-heading">
                          <h2 className="pb-0">
                            Sample Details
                            <center></center>
                          </h2>
                        </div>
                        {pageLoader || checkpageLoader ? (
                          <Loader />
                        ) : (
                          <div className="info-content">
                            <div className="row">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Purpose of Application
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <select
                                        className={`form-select ${
                                          applicationDetails?.purposeOfTestErrMsg
                                            ? "border-danger op05"
                                            : ""
                                        }`}
                                        aria-label="Default select example"
                                        name="purposeOfTest"
                                        onChange={(e) =>
                                          handleAppDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest ||
                                          modeOfPayment === "Biosurveillance"
                                        }
                                        value={
                                          modeOfPayment === "Biosurveillance"
                                            ? 1
                                            : applicationDetails?.purposeOfTest
                                        }
                                      >
                                        <option selected>-- Select --</option>
                                        {purposeOfTestOptions &&
                                          purposeOfTestOptions
                                            .filter((x) =>
                                              modeOfPayment ===
                                              "Biosurveillance"
                                                ? x.id === 1
                                                : x.name !== "Biosurveillance"
                                            )
                                            .map((x) => (
                                              <option key={x.id} value={x.id}>
                                                {x.name}
                                              </option>
                                            ))}
                                      </select>
                                      {applicationDetails?.purposeOfTestErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Purpose of Application.
                                        </div>
                                      )}

                                      {applicationDetails?.purposeOfTest ===
                                        7 && (
                                        <div className="col-lg-12 mt-2">
                                          <input
                                            type="text"
                                            className={`form-control ${
                                              !applicationDetails?.otherPurposeOfTest
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            placeholder={
                                              showPlaceholder
                                                ? "Enter Purpose of Application"
                                                : ""
                                            }
                                            name="otherPurposeOfTest"
                                            value={
                                              applicationDetails?.otherPurposeOfTest
                                            }
                                            maxLength={100}
                                            onChange={(e) =>
                                              handleAppDetails(e, "string")
                                            }
                                          />
                                          {applicationDetails?.otherPurposeOfTestErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              {
                                                applicationDetails.otherPurposeOfTestErrMsg
                                              }
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-3">
                                  <label htmlFor="crossReference">
                                    Cross Reference
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="crossReference"
                                    name="crossReference"
                                    value={applicationDetails?.crossReference}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledge ||
                                      IsAcknowledgeRequest ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={100}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleAppDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>
                              {modeOfPayment === "Biosurveillance" && (
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Biosurveillance Program
                                          <span className="star-red">*</span>
                                        </label>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="col-lg-12 mt-2">
                                          <select
                                            className={`form-select ${
                                              applicationDetails?.bioSurveillanceProgramErrMsg
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            aria-label="Default select example"
                                            name="bioSurveillanceProgram"
                                            value={
                                              applicationDetails?.bioSurveillanceProgram
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleAppDetails(e, "string")
                                            }
                                          >
                                            <option selected>
                                              -- Select --
                                            </option>
                                            {bioSurveillanceProgramsOptions &&
                                              bioSurveillanceProgramsOptions.map(
                                                (x) => {
                                                  return (
                                                    <option value={x.label}>
                                                      {x.label}
                                                    </option>
                                                  );
                                                }
                                              )}
                                          </select>
                                          {applicationDetails?.bioSurveillanceProgramErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please select Biosurveillance
                                              Program.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row mt-2">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Country of Origin
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <select
                                          id="countryOfBirth"
                                          name="countryOfBirth"
                                          value={
                                            applicationDetails?.countryOfBirth
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleAppDetails(e,"countryOfBirth")
                                          }
                                          required
                                        >
                                          <option value="" disabled hidden>
                                            Choose a Country
                                          </option>
                                          {countryOfOriginOptions &&
                                            countryOfOriginOptions.map((x) => {
                                              return (
                                                <option value={x.name}>
                                                  {x.name}
                                                </option>
                                              );
                                            })}
                                  </select>
                                      {applicationDetails?.countryOfBirthErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Country of Origin.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor="referringVeterinarian"
                                  >
                                    Country of Destination
                                    {applicationDetails?.purposeOfTest ===
                                      4 && <span className="star-red">*</span>}
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <select
                                    id="exportercountryOfDestination"
                                    name="exportercountryOfDestination"
                                    value={
                                      clinicalHistory?.exportercountryOfDestination
                                    }
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    className="form-control"
                                    onChange={(e) =>
                                      handleClinicalDetails(e, "string")
                                    }
                                    required
                                  >
                                    <option value="" disabled hidden>
                                      Choose a Country
                                    </option>
                                    {countryOfDestinationOptions &&
                                      countryOfDestinationOptions.map((x) => {
                                        return (
                                          <option value={x.name}>
                                            {x.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                  {clinicalHistory?.exportercountryOfDestinationErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Country of Destination.
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Date of Import
                                    {applicationDetails?.purposeOfTest === 5 && <span className="star-red">*</span>}
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <div
                                    className="input-group date"
                                    id="datepicker"
                                  >
                                    <input
                                      type="date"
                                      className={`form-control`}
                                      name="dateOfImport"
                                      max={
                                        applicationDetails?.purposeOfTest ===
                                          4 ||
                                        applicationDetails?.purposeOfTest === 5
                                          ? ""
                                          : maxdate
                                      }
                                      value={
                                        applicationDetails?.dateOfImport
                                          ? moment(
                                              applicationDetails?.dateOfImport
                                            ).format("YYYY-MM-DD")
                                          : ""
                                      }
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      onChange={(e) =>
                                        handleAppDetails(e, "string")
                                      }
                                    />
                                    {clinicalHistory?.dateImportDateErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          {
                                            clinicalHistory?.dateImportDateErrMsg
                                          }
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <label htmlFor="crossReference">
                                    Date to be Exported
                                    {applicationDetails?.purposeOfTest === 4 && <span className="star-red">*</span>}
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="date"
                                    id="dateExportedDate"
                                    name="dateExportedDate"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    value={
                                      clinicalHistory?.dateExportedDate
                                        ? moment(
                                            clinicalHistory?.dateExportedDate
                                          ).format("YYYY-MM-DD")
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleClinicalDetails(e, "string")
                                    }
                                    className="form-control"
                                  />

                                  {clinicalHistory?.dateExportedDateErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Date to be Exported.
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div className="row-mt-2">
                                  <div className="row">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Sampling From Date
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="datetime-local"
                                        className={`form-control ${
                                          applicationDetails?.samplingToDate &&
                                          moment(
                                            applicationDetails?.samplingToDate
                                          ).isBefore(
                                            moment(
                                              applicationDetails?.samplingFromDate
                                            )
                                          )
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="samplingFromDate"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          applicationDetails?.samplingFromDate
                                            ? moment(
                                                applicationDetails?.samplingFromDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : ""
                                        }
                                        onChange={(e) =>
                                          handleAppDetails(e, "datetime-local")
                                        }
                                        max={
                                          applicationDetails?.samplingToDate
                                            ? moment(
                                                applicationDetails?.samplingToDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : maxDateTime
                                        }
                                      />
                                      {applicationDetails?.samplingFromDateErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          {
                                            applicationDetails?.samplingFromDateErrMsg
                                          }
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor="courierTrackingNo"
                                      >
                                        Sampling To Date
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="datetime-local"
                                        className={`form-control ${
                                          applicationDetails?.samplingFromDate &&
                                          moment(
                                            applicationDetails?.samplingToDate
                                          ).isBefore(
                                            moment(
                                              applicationDetails?.samplingFromDate
                                            )
                                          )
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="samplingToDate"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          applicationDetails?.samplingToDate
                                            ? moment(
                                                applicationDetails?.samplingToDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : ""
                                        }
                                        onChange={(e) =>
                                          handleAppDetails(e, "datetime-local")
                                        }
                                        min={
                                          applicationDetails?.samplingFromDate
                                            ? moment(
                                                applicationDetails?.samplingFromDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : ""
                                        }
                                      />
                                      {applicationDetails?.samplingToDateErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          {
                                            applicationDetails?.samplingToDateErrMsg
                                          }
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label htmlFor="sampledBy">
                                    Sampled By
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="sampledBy"
                                    name="sampledBy"
                                    value={applicationDetails?.sampledBy}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={100}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleAppDetails(e, "string")
                                    }
                                  />

                                  {applicationDetails?.sampledByErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Sampled By.
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor="referringVeterinarian"
                                  >
                                    Referring Veterinarian
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="referringVeterinarian"
                                    maxLength={100}
                                    value={
                                      applicationDetails?.referringVeterinarian
                                    }
                                    onChange={(e) =>
                                      handleAppDetails(e, "string")
                                    }
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    <a
                                      href="#"
                                      className="font-weight-500"
                                      onClick={handleToggleFarmDetails}
                                    >
                                      Farm/Location Details{" "}
                                      {showFarmDetails ? "[-]" : "[+]"}
                                    </a>
                                  </label>
                                </div>
                              </div>
                              {showFarmDetails && (
                                <>
                                  {modeOfPayment === "Biosurveillance" && (
                                    <div className="row mb-3">
                                      <div className="col-lg-6">
                                        <div className="row">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-check-label"
                                              htmlFor=""
                                            >
                                              Farm Code
                                            </label>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="col-lg-12 mt-2">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                name="farmCode"
                                                value={
                                                  applicationDetails?.farmCode
                                                }
                                                disabled={
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                }
                                                onChange={(e) =>
                                                  handleAppDetails(e, "string")
                                                }
                                              >
                                                <option selected>
                                                  -- Select --
                                                </option>
                                                {premisesCodeOptions.map(
                                                  (option) => (
                                                    <option
                                                      key={option.value}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </option>
                                                  )
                                                )}
                                                <option
                                                  key="specialFarmCode"
                                                  value="specialfarmCode"
                                                >
                                                  Special Farm Code
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {applicationDetails?.farmCode ===
                                    "specialfarmCode" && (
                                    <div className="row mb-3">
                                      <div className="col-lg-6">
                                        <div className="row align-items-center">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-check-label"
                                              htmlFor="specialFarmCode"
                                            >
                                              Special Farm Code
                                            </label>
                                          </div>
                                          <div className="col-lg-6">
                                            <input
                                              id="specialFarmCode"
                                              type="text"
                                              className="form-control"
                                              disabled={
                                                isCancelRequest ||
                                                IsAcknowledgeRequest ||
                                                IsAcknowledge ||
                                                IsSubmitresultRequest
                                              }
                                              placeholder={
                                                showPlaceholder
                                                  ? "Enter Special Farm Code"
                                                  : ""
                                              }
                                              name="specialFarmCode"
                                              value={
                                                applicationDetails?.specialFarmCode ||
                                                ""
                                              }
                                              maxLength={100}
                                              onChange={(e) =>
                                                handleAppDetails(e, "string")
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  <div className="row align-items-center">
                                    <div className="col-lg-3">
                                      <label
                                        htmlFor="latitude"
                                        className="mb-0"
                                      >
                                        Latitude (Decimal Degrees)
                                      </label>
                                    </div>

                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="latitude"
                                        name="latitude"
                                        value={applicationDetails?.latitude}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        placeholder={
                                          showPlaceholder ? "123.123456" : ""
                                        }
                                        onChange={(e) =>
                                          handleAppDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>

                                    <div className="col-lg-3">
                                      <label
                                        htmlFor="longitude"
                                        className="mb-0"
                                      >
                                        Longitude (Decimal Degrees)
                                      </label>
                                    </div>

                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="longitude"
                                        name="longitude"
                                        value={applicationDetails?.longitude}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        placeholder={
                                          showPlaceholder ? "123.123456" : ""
                                        }
                                        onChange={(e) =>
                                          handleAppDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-2 align-items-center">
                                    <div className="col-lg-3">
                                      <label htmlFor="locationName">
                                        Location Name
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="locationName"
                                        name="locationName"
                                        value={applicationDetails?.locationName}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        onChange={(e) =>
                                          handleAppDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor="addressType"
                                      >
                                        Farm/Location Address
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-checked">
                                        <label
                                          className="form-check-label"
                                          htmlFor="local"
                                        >
                                          <input
                                            type="radio"
                                            id="local"
                                            name="addressType"
                                            value="Local"
                                            className="form-check-input"
                                            checked={
                                              applicationDetails?.addressType ===
                                              "Local"
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleAppDetails(e, "radio")
                                            }
                                          />
                                          Local
                                        </label>

                                        <label
                                          className="form-check-label"
                                          htmlFor="foreign"
                                        >
                                          <input
                                            type="radio"
                                            id="foreign"
                                            name="addressType"
                                            value="Foreign"
                                            className="form-check-input"
                                            checked={
                                              applicationDetails?.addressType ===
                                              "Foreign"
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleAppDetails(e, "radio")
                                            }
                                          />
                                          Foreign
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="address">
                                    <div className="row mt-2">
                                      <div
                                        className={
                                          applicationDetails?.addressType ===
                                            "Local" &&
                                          modeOfPayment !== "Biosurveillance"
                                            ? "col-lg-9"
                                            : "col-lg-12"
                                        }
                                      >
                                        <div>
                                          <label htmlFor="postalCode">
                                            Postal Code
                                          </label>
                                          <input
                                            type="text"
                                            id="postalCode"
                                            name="postalCode"
                                            className="form-control"
                                            value={
                                              applicationDetails?.postalCode
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            maxLength={10}
                                            onChange={(e) => {
                                              const newValue = e.target.value;
                                              setpostalCode({
                                                ...postalCode,
                                                postalCode: newValue,
                                              });
                                              setApplicationDetails({
                                                ...applicationDetails,
                                                postalCode: newValue,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                      {modeOfPayment !== "Biosurveillance" &&
                                        applicationDetails?.addressType ===
                                          "Local" && (
                                          <div className="col-lg-3">
                                            <div className="row">
                                              <div className="col-lg-12">
                                                <label htmlFor="button"></label>
                                                <br />
                                                <div>
                                                  <Button
                                                    className="btttn"
                                                    onClick={() => {
                                                      if (
                                                        applicationDetails.addressType
                                                      ) {
                                                        fetchData(
                                                          applicationDetails.addressType
                                                        );
                                                      } else {
                                                        message(
                                                          NotifyType.Error,
                                                          "Please select an address type (Local or Foreign) before retrieving."
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    Retrieve
                                                  </Button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>

                                    <div className="row mt-2">
                                      <div>
                                        <label htmlFor="streetName">
                                          Street/Road Name
                                        </label>
                                        <input
                                          type="text"
                                          id="streetName"
                                          name="streetName"
                                          value={applicationDetails?.streetName}
                                          className="form-control"
                                          maxLength={100}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-4">
                                      <div className="col-lg-4">
                                        <label htmlFor="blockHouseNo">
                                          Block/House No
                                        </label>
                                        <input
                                          type="text"
                                          id="blockHouseNo"
                                          name="blockHouseNo"
                                          value={
                                            applicationDetails?.blockHouseNo
                                          }
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                      <div className="block">
                                        <label htmlFor="level">Level</label>
                                        <input
                                          type="text"
                                          id="level"
                                          name="level"
                                          value={applicationDetails?.level}
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <label htmlFor="unitNo">Unit No</label>
                                        <input
                                          type="text"
                                          id="unitNo"
                                          name="unitNo"
                                          value={applicationDetails?.unitNo}
                                          className="form-control"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-2">
                                      <div>
                                        <label htmlFor="buildingName">
                                          Building Name
                                        </label>
                                        <input
                                          type="text"
                                          id="buildingName"
                                          name="buildingName"
                                          value={
                                            applicationDetails?.buildingName
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-4">
                                      <div className="col-lg-6">
                                        <label htmlFor="cityName">
                                          City Name
                                        </label>
                                        <input
                                          type="text"
                                          id="cityName"
                                          name="cityName"
                                          value={applicationDetails?.cityName}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>

                                      <div className="col-lg-6">
                                        <label htmlFor="State">
                                          State/Province
                                        </label>
                                        <input
                                          type="text"
                                          id="state"
                                          name="state"
                                          value={applicationDetails?.state}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-2">
                                      <div>
                                        <label htmlFor="country">Country</label>
                                        <input
                                          type="text"
                                          id="country"
                                          name="country"
                                          value={applicationDetails?.country}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          onChange={(e) =>
                                            handleAppDetails(e, "string")
                                          }
                                          maxLength={100}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="col-lg-3">
                                <label className="form-check-label">
                                  <a
                                    href=""
                                    className="font-weight-500"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleQuarantineInfo();
                                    }}
                                  >
                                    Quarantine Information{" "}
                                    {showQuarantineInfo ? "[-]" : "[+]"}
                                  </a>
                                </label>

                                {showQuarantineInfo && (
                                  <div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-check">
                                          <input
                                            type="checkbox"
                                            name="inQuarantine"
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            checked={
                                              clinicalHistory?.inQuarantine
                                            }
                                            onChange={(e) =>
                                              handleClinicalDetails(
                                                e,
                                                "checkbox"
                                              )
                                            }
                                            className="form-check-input mt10"
                                          />
                                          <label className="form-check-label">
                                            In Quarantine
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    {clinicalHistory?.inQuarantine && (
                                      <div className="col-lg-12">
                                        <div className="col-lg-9">
                                          <label className="form-check-label">
                                            Import Licence No
                                          </label>
                                        </div>
                                        <input
                                          type="text"
                                          id="importLicenseNo"
                                          name="importLicenseNo"
                                          maxLength={100}
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "string")
                                          }
                                          value={
                                            clinicalHistory?.importLicenseNo
                                          }
                                          className="form-control"
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="personal-info">
                        <div className="info-heading">
                          <h2 className="pb-0">
                            Clinical History &amp; Disease Signs
                          </h2>
                        </div>

                        {pageLoader || checkpageLoader ? (
                          <Loader />
                        ) : (
                          <div className="info-content">
                            <div className="row">
                              <div className="col-lg-2">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault1"
                                >
                                  Health Status
                                  <span className="star-red">*</span>
                                </label>
                              </div>
                              <div className="col-lg-8">
                                {clinicalHistoryOptions &&
                                  clinicalHistoryOptions.map((x) => {
                                    return (
                                      <div className="form-check form-check-inline">
                                        <input
                                          className={`form-check-input mt10 ${
                                            clinicalHistory?.clinicalHistoryErrMsg
                                              ? "border-danger"
                                              : ""
                                          }`}
                                          type="radio"
                                          name="clinicalHistory"
                                          id={`${x.name}-check`}
                                          value={x.id}
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "number")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          checked={
                                            clinicalHistory.clinicalHistory ==
                                            x.id
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`${x.name}-check`}
                                        >
                                          {x.name}
                                        </label>
                                      </div>
                                    );
                                  })}
                                {clinicalHistory?.clinicalHistoryErrMsg && (
                                  <div className="error-message">
                                    <FontAwesomeIcon
                                      className="me-1"
                                      icon={faCircleExclamation}
                                    />
                                    Please fill Clinical History.
                                  </div>
                                )}
                                {clinicalHistory?.clinicalHistory == 2 ? (
                                  <div className="row">
                                    <div className="col-lg-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        <b>Disease Started on</b>
                                      </label>
                                    </div>
                                    <div className="col-lg-4 align-disease">
                                      <div
                                        className="input-group date"
                                        id="datepicker"
                                      >
                                        <input
                                          type="date"
                                          className={`form-control`}
                                          max={maxdate}
                                          name="diseaseStartedOn"
                                          value={
                                            clinicalHistory?.diseaseStartedOn
                                              ? moment(
                                                  clinicalHistory?.diseaseStartedOn
                                                ).format("YYYY-MM-DD")
                                              : ""
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "date")
                                          }
                                          required
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6 align-disease">
                                      <b>OR</b>
                                      <input
                                        type="number"
                                        className="form-control ms-2"
                                        placeholder=""
                                        name="ago"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        maxLength={100}
                                        onChange={(e) =>
                                          handleClinicalDetails(e, "number")
                                        }
                                        value={clinicalHistory?.ago}
                                      />
                                      <select
                                        className="form-select ms-2"
                                        aria-label="Default select example"
                                        name="yearsmonth"
                                        value={clinicalHistory?.yearsmonth}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        onChange={(e) =>
                                          handleClinicalDetails(e, "number")
                                        }
                                      >
                                        <option selected />

                                        <option value={1}>Days</option>
                                        <option value={2}>Weeks</option>
                                        <option value={3}>Months</option>
                                        <option value={4}>Years</option>
                                      </select>
                                      <p className="ms-2">ago</p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-2">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault1"
                                >
                                  <a href="#" onClick={handleDiseaseSignClick}>
                                    Disease Sign: [
                                    {showAdditionalContent ? "-" : "+"}]
                                  </a>
                                </label>
                              </div>
                            </div>

                            <div className="row">
                              {showAdditionalContent && (
                                <div className="col-lg-12">
                                  <div className="row">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Disease Pattern
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="diseasePattern"
                                        value={clinicalHistory?.diseasePattern}
                                        onChange={(e) =>
                                          handleClinicalDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      >
                                        <option selected> -- Select --</option>
                                        {diseasePatternOptions &&
                                          diseasePatternOptions.map((x) => {
                                            return (
                                              <option value={x.id}>
                                                {x.name}
                                              </option>
                                            );
                                          })}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Total No. on Premises
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        name="totalNoOnPermises"
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleClinicalDetails(e, "number");
                                          }
                                        }}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          clinicalHistory?.totalNoOnPermises
                                        }
                                      />
                                    </div>
                                    <div className="col-lg-1"> </div>
                                    <div className="col-lg-1">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        No. Dead Daily
                                      </label>
                                    </div>
                                    <div className="col-lg-2">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        value={clinicalHistory?.noDeadDaily}
                                        name="noDeadDaily"
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleClinicalDetails(e, "number");
                                          }
                                        }}
                                        maxLength={100}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        No. or % Diseased
                                      </label>
                                    </div>
                                    <div className="col-lg-4">
                                      <div className="d-flex">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={clinicalHistory?.noOrDisease}
                                          name="noOrDisease"
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleClinicalDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          maxLength={50}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <div className="col-lg-1"></div>
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          name="noOrDiseasedOptions"
                                          value={
                                            clinicalHistory?.noOrDiseasedOptions
                                          }
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "number")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        >
                                          <option selected />
                                          {noOrDiseasedOptions &&
                                            noOrDiseasedOptions.map((x) => {
                                              return (
                                                <option value={x.id}>
                                                  {x.name}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      </div>
                                      {clinicalHistory?.noOrDiseasedOptionsErrMsg && (
                                        <div className="error-message d-flex justify-content-start mt-1">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill No. or % Diseased options.
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-lg-1">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Total No. Dead
                                      </label>
                                    </div>
                                    <div className="col-lg-2">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        name="totalNoDead"
                                        value={clinicalHistory?.totalNoDead}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleClinicalDetails(e, "number");
                                          }
                                        }}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label className="form-check-label">
                                        Farm Area
                                      </label>
                                    </div>
                                    <div className="col-lg-4">
                                      <div className="d-flex">
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=""
                                          value={clinicalHistory?.farmArea}
                                          name="farmArea"
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleClinicalDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <div className="col-lg-1"></div>
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          value={
                                            clinicalHistory?.farmAreaOptions
                                          }
                                          name="farmAreaOptions"
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "number")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        >
                                          <option selected />
                                          {farmAreaOptions &&
                                            farmAreaOptions.map((x) => {
                                              return (
                                                <option value={x.id} key={x.id}>
                                                  {x.name}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      </div>
                                      {clinicalHistory?.farmAreaOptionsErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Farm Area options.
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-lg-1">
                                      <label className="form-check-label">
                                        No. Affected
                                      </label>
                                    </div>
                                    <div className="col-lg-2">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        name="noAffected"
                                        value={clinicalHistory?.noAffected}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleClinicalDetails(e, "number");
                                          }
                                        }}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Total No. of Units
                                      </label>
                                    </div>

                                    <div className="col-lg-4">
                                      <div className="d-flex">
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=""
                                          value={
                                            clinicalHistory?.totalNoOfUnits
                                          }
                                          name="totalNoOfUnits"
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleClinicalDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <div className="col-lg-1"></div>
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          value={
                                            clinicalHistory?.noOfUnitsOptions
                                          }
                                          name="noOfUnitsOptions"
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "number")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        >
                                          <option selected />
                                          {totalNoOfUnitsOptions &&
                                            totalNoOfUnitsOptions.map((x) => {
                                              return (
                                                <option value={x.id}>
                                                  {x.name}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      </div>

                                      {clinicalHistory?.noOfUnitsOptionsErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Total No. of Units
                                          options.
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-lg-1">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Unit Size
                                      </label>
                                    </div>

                                    <div className="col-lg-4">
                                      <div className="d-flex">
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=""
                                          name="unitSize"
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleClinicalDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          value={clinicalHistory?.unitSize}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <div className="col-lg-1"></div>
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          name="unitSizeOptions"
                                          value={
                                            clinicalHistory?.unitSizeOptions
                                          }
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "number")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledge ||
                                            IsAcknowledgeRequest ||
                                            IsSubmitresultRequest
                                          }
                                        >
                                          <option selected />
                                          {unitSizeOptions &&
                                            unitSizeOptions.map((x) => {
                                              return (
                                                <option value={x.id}>
                                                  {x.name}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      </div>

                                      {clinicalHistory?.unitSizeOptionsErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Unit Size options.
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Age Affected
                                      </label>
                                    </div>
                                    <div className="col-lg-4">
                                      <div className="d-flex">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={clinicalHistory?.ageAffected}
                                          name="ageAffected"
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleClinicalDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          placeholder=""
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <div className="col-lg-1"></div>

                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          value={
                                            clinicalHistory?.ageAffectedOptions
                                          }
                                          name="ageAffectedOptions"
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "number")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledge ||
                                            IsAcknowledgeRequest ||
                                            IsSubmitresultRequest
                                          }
                                        >
                                          <option selected />

                                          <option value={1}>days</option>
                                          <option value={2}>weeks</option>
                                          <option value={3}>months</option>
                                          <option value={4}>years</option>
                                        </select>
                                      </div>
                                      {clinicalHistory?.ageAffectedOptionsErrMsg && (
                                        <div className="error-message d-flex justify-content-start mt-1">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Age Affected options.
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-lg-1">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Size Affected
                                      </label>
                                    </div>
                                    <div className="col-lg-2">
                                      <input
                                        type="number"
                                        value={clinicalHistory?.sizeAffected}
                                        name="sizeAffected"
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleClinicalDetails(e, "number");
                                          }
                                        }}
                                        className="form-control"
                                        placeholder=""
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Other Species/Breed Affected
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        value={
                                          clinicalHistory?.otherSpeciesOrBreedAff
                                        }
                                        name="otherSpeciesOrBreedAff"
                                        onChange={(e) =>
                                          handleClinicalDetails(e, "string")
                                        }
                                        maxLength={100}
                                        className="form-control"
                                        placeholder=""
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-2">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Clinical Signs &amp; Remarks
                                      </label>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <textarea
                                          className="form-control"
                                          id="floatingTextarea"
                                          placeholder=""
                                          value={
                                            clinicalHistory?.clinicalSignAndRemarks
                                          }
                                          name="clinicalSignAndRemarks"
                                          onChange={(e) =>
                                            handleClinicalDetails(e, "string")
                                          }
                                          maxLength={500}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <p className="text-muted small mt-1">
                                          {clinicalHistory
                                            ?.clinicalSignAndRemarks?.length ||
                                            0}{" "}
                                          / 500 characters
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="row">
                              <div className="row">
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="vaccinationHistory"
                                  >
                                    <a
                                      href=""
                                      className="font-weight-500"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        toggleVaccinationHistory();
                                      }}
                                    >
                                      Vaccination History{" "}
                                      {isVaccinationHistoryExpanded
                                        ? "[-]"
                                        : "[+]"}
                                    </a>
                                  </label>
                                </div>
                                {isVaccinationHistoryExpanded && (
                                  <div className="col-lg-12">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Clinical/Vaccination History
                                      </label>
                                    </div>
                                    <textarea
                                      id="vaccinationHistory"
                                      name="vaccinationHistory"
                                      value={
                                        clinicalHistory?.vaccinationHistory
                                      }
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      maxLength={500}
                                      className="form-control"
                                      onChange={(e) =>
                                        handleClinicalDetails(e, "string")
                                      }
                                    />
                                    <p className="text-muted small mt-1">
                                      {clinicalHistory?.vaccinationHistory
                                        ?.length || 0}{" "}
                                      / 500 characters
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {isCancelRequest ? (
                        <div className="personal-info">
                          <div className="clonable-block" data-toggle="cloner">
                            <div className="clonable" data-clone-number="1">
                              <div className="info-heading">
                                <h2>
                                  Reason(s) for cancellation
                                  <span className="star-red">*</span>
                                </h2>
                              </div>
                              <div className="info-content">
                                <textarea
                                  className="form-control"
                                  placeholder=""
                                  name="cancel-request-comments"
                                  value={cancelComments}
                                  onChange={(e) =>
                                    setCancelComments(e.target.value)
                                  }
                                  maxLength={500}
                                ></textarea>
                                {cancelCommentsErrMsg && (
                                  <div className="error-message">
                                    <FontAwesomeIcon
                                      className="me-1"
                                      icon={faCircleExclamation}
                                    />
                                    Please fill Reason(s) for cancellation.
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={2} title="Samples & Tests">
                      <div>
                        {rejectedTestsMessage && (
                          <div className="alert alert-warning">
                            {rejectedTestsMessage}
                          </div>
                        )}
                        {samples &&
                          samples.map((sample, index) => (
                            <div className="personal-info">
                              <div
                                className="clonable-block"
                                data-toggle="cloner"
                              >
                                <div className="clonable" data-clone-number={1}>
                                  <div className="info-heading">
                                    {amendCase !== "CASE4" &&
                                    !isCancelRequest &&
                                    !IsAcknowledge &&
                                    !IsSubmitresultRequest &&
                                    !IsAcknowledgeRequest ? (
                                      <ul className="card-icons float-end">
                                        <li>
                                          <button
                                            className="icon-button"
                                            title="New"
                                            onClick={handleAddSample}
                                          >
                                            <FontAwesomeIcon icon={faPlus} />
                                          </button>
                                        </li>
                                        <li className="copy-button-container">
                                          <button
                                            className="icon-button"
                                            title="Copy"
                                            onClick={() =>
                                              handleCopyButtonClick(index)
                                            }
                                          >
                                            <FontAwesomeIcon icon={faCopy} />
                                          </button>
                                          <input
                                            type="number"
                                            className="copy-input"
                                            min="1"
                                            value={copyCount}
                                            onChange={handleCopyInputChange}
                                          />
                                        </li>

                                        <li>
                                          <button
                                            className="icon-button"
                                            onClick={() =>
                                              handleDeleteSample(sample?.id)
                                            }
                                          >
                                            <FontAwesomeIcon
                                              icon={faTrashCan}
                                            />
                                          </button>
                                        </li>
                                      </ul>
                                    ) : (
                                      ""
                                    )}
                                    <h2 className="pb-0">
                                      Serial number {index + 1}
                                    </h2>
                                  </div>
                                  <div className="info-content">
                                    <div className="table-responsive mt-2 mb-2 ">
                                      <table className="table table-striped product_table start_table">
                                        <thead>
                                          <tr>
                                            <th className="w-34">
                                              Animal Type
                                              <span className="star-red">
                                                *
                                              </span>
                                            </th>
                                            <th className="w-34">
                                              Species/Breed
                                              <span className="star-red">
                                                *
                                              </span>{" "}
                                            </th>
                                            <th className="w-34">
                                              Sample Description
                                              <span className="star-red">
                                                *
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <Select
                                                classNamePrefix={
                                                  sample?.speciesErrMsg
                                                    ? "border-danger"
                                                    : ""
                                                }
                                                value={speciesSelectOptions.find(
                                                  (option) =>
                                                    option.value ===
                                                    sample.species
                                                )}
                                                isDisabled={
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                }
                                                options={speciesSelectOptions}
                                                styles={customStyles}
                                                onChange={(selectedOption) => {
                                                  handleSelectChange(
                                                    index,
                                                    "species"
                                                  )(selectedOption);
                                                }}
                                                placeholder={
                                                  showPlaceholder
                                                    ? "Select Animal Type"
                                                    : ""
                                                }
                                              />
                                              {sample.species?.toUpperCase() === "OTHERS" && (
                                                <input
                                                  type="text"
                                                  className="form-control mt-2"
                                                  value={sample?.otherSpecies}
                                                  name="otherSpecies"
                                                  onChange={handleFormChange(
                                                    index,
                                                    "string"
                                                  )}
                                                  maxLength={100}
                                                  disabled={
                                                    isCancelRequest ||
                                                    IsAcknowledge ||
                                                    IsAcknowledgeRequest ||
                                                    IsSubmitresultRequest
                                                  }
                                                  placeholder={
                                                    showPlaceholder
                                                      ? "Enter Animal Type"
                                                      : ""
                                                  }
                                                />
                                              )}
                                              {sample?.speciesErrMsg && (
                                                <div className="error-message">
                                                  <FontAwesomeIcon
                                                    className="me-1"
                                                    icon={faCircleExclamation}
                                                  />
                                                  Please fill Animal
                                                  Type/Species.
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Select
                                                classNamePrefix={
                                                  sample?.breedErrMsg
                                                    ? "border-danger"
                                                    : ""
                                                }
                                                value={
                                                  sample.breed
                                                    ? sample.breedOptions?.find(
                                                        (opt) =>
                                                          opt.value ===
                                                          sample.breed
                                                      )
                                                    : null
                                                }
                                                name="breed"
                                                isDisabled={
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                }
                                                onChange={handleSelectChange(
                                                  index,
                                                  "breed"
                                                )}
                                                options={
                                                  sample.breedOptions || []
                                                }
                                                styles={customStyles}
                                              />

                                              {sample.breed?.toUpperCase() === "OTHERS" && (
                                                <input
                                                  type="text"
                                                  className="form-control mt-2"
                                                  name="otherBreed"
                                                  value={sample?.otherBreed}
                                                  onChange={handleFormChange(
                                                    index,
                                                    "string"
                                                  )}
                                                  maxLength={100}
                                                  disabled={
                                                    isCancelRequest ||
                                                    IsAcknowledgeRequest ||
                                                    IsAcknowledge ||
                                                    IsSubmitresultRequest
                                                  }
                                                  placeholder={
                                                    showPlaceholder
                                                      ? "Enter Species/Breed"
                                                      : ""
                                                  }
                                                />
                                              )}
                                              {sample?.breedErrMsg && (
                                                <div className="error-message">
                                                  <FontAwesomeIcon
                                                    className="me-1"
                                                    icon={faCircleExclamation}
                                                  />
                                                  Please fill Species/Breed.
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Select
                                                classNamePrefix={
                                                  sample?.specimenDescriptionErrMsg
                                                    ? "border-danger"
                                                    : ""
                                                }
                                                value={
                                                  sample.specimenDescription
                                                    ? sample.specimenOptions?.find(
                                                        (opt) =>
                                                          opt.value ===
                                                          sample.specimenDescription
                                                      )
                                                    : null
                                                }
                                                name="specimenDescription"
                                                isDisabled={
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                }
                                                onChange={handleSelectChange(
                                                  index,
                                                  "specimenDescription"
                                                )}
                                                options={
                                                  sample.specimenOptions || []
                                                }
                                                styles={customStyles}
                                              />

                                              {sample.specimenDescription?.toUpperCase() ===
                                                "OTHERS" && (
                                                <input
                                                  type="text"
                                                  className="form-control mt-2"
                                                  maxLength={100}
                                                  name="otherSpecimenDescription"
                                                  value={
                                                    sample?.otherSpecimenDescription
                                                  }
                                                  disabled={
                                                    isCancelRequest ||
                                                    IsAcknowledgeRequest ||
                                                    IsAcknowledge ||
                                                    IsSubmitresultRequest
                                                  }
                                                  onChange={handleFormChange(
                                                    index,
                                                    "string"
                                                  )}
                                                  placeholder={
                                                    showPlaceholder
                                                      ? "Enter Specimen Desc"
                                                      : ""
                                                  }
                                                />
                                              )}
                                              {sample?.specimenDescriptionErrMsg && (
                                                <div className="error-message">
                                                  <FontAwesomeIcon
                                                    className="me-1"
                                                    icon={faCircleExclamation}
                                                  />
                                                  Please fill Specimen
                                                  Description.
                                                </div>
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="fnt-wg tr-ignore">
                                              <div className="mb-3 ">
                                                <div className="mb-2">
                                                  <label
                                                    htmlFor="staticEmail"
                                                    className="col-form-label"
                                                  >
                                                    Sample Marking{" "}
                                                    <span className="star-red">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="input-group date">
                                                    <input
                                                      type="text"
                                                      className={`form-control ${
                                                        sample?.sampleMarkingErrMsg
                                                          ? "border-danger"
                                                          : ""
                                                      }`}
                                                      placeholder=""
                                                      name="sampleMarking"
                                                      value={
                                                        sample?.sampleMarking
                                                      }
                                                      maxLength={100}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      onChange={handleFormChange(
                                                        index,
                                                        "string"
                                                      )}
                                                    />
                                                  </div>
                                                  {sample?.sampleMarkingErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      {
                                                        sample.sampleMarkingErrMsg
                                                      }
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </td>

                                            <td className="fnt-wg tr-ignore">
                                              <div className="mb-3 ">
                                                <div className="mb-2">
                                                  <label
                                                    htmlFor="staticEmail"
                                                    className="col-form-label"
                                                  >
                                                    Number of Samples
                                                    <span className="star-red">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="input-group date">
                                                    <input
                                                      type="number"
                                                      min="1"
                                                      name="noOfSamples"
                                                      className="form-control"
                                                      value={
                                                        sample?.noOfSamples ?? 1
                                                      }
                                                      disabled={
                                                        amendCase == "CASE4" ||
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      onChange={handleFormChange(
                                                        index,
                                                        "number"
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td className="fnt-wg tr-ignore">
                                              <div className="mb-3 ">
                                                <div className="mb-2">
                                                  <label
                                                    htmlFor="staticEmail"
                                                    className="col-form-label"
                                                  >
                                                    Test Information{" "}
                                                    <span className="star-red">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="input-group date">
                                                    <button
                                                      className={`btn btn-outline-success w-100 ${
                                                        sample?.labAquaTestDetailErrMsg
                                                          ? "border-danger"
                                                          : ""
                                                      }`}
                                                      type="button"
                                                      onClick={() =>
                                                        handleShowSearchTestsModal(
                                                          index
                                                        )
                                                      }
                                                      disabled={
                                                        amendCase === "CASE4" ||
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                    >
                                                      Search Test
                                                    </button>
                                                    {sample?.labAquaTestDetailErrMsg && (
                                                      <div className="error-message">
                                                        <FontAwesomeIcon
                                                          className="me-1"
                                                          icon={
                                                            faCircleExclamation
                                                          }
                                                        />
                                                        Please add Test
                                                        Information.
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>

                                          {/*<tr>
                                            <td className="fnt-wg tr-ignore">
                                              <div className="mb-3 ">
                                                <div className="mb-2">
                                                  <label
                                                    htmlFor="staticEmail"
                                                    className="col-form-label"
                                                  >
                                                    Latitude (Decimal Degrees)
                                                  </label>
                                                  <div className="input-group date">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "123.123456"
                                                          : ""
                                                      }
                                                      name="latitude"
                                                      value={sample?.latitude}
                                                      maxLength={100}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      onChange={handleFormChange(
                                                        index,
                                                        "string"
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>

                                            <td className="fnt-wg tr-ignore">
                                              <div className="mb-3 ">
                                                <div className="mb-2">
                                                  <label
                                                    htmlFor="staticEmail"
                                                    className="col-form-label"
                                                  >
                                                    Longitude (Decimal Degrees)
                                                  </label>
                                                  <div className="input-group date">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "123.123456"
                                                          : ""
                                                      }
                                                      name="longitude"
                                                      value={sample?.longitude}
                                                      maxLength={100}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      onChange={handleFormChange(
                                                        index,
                                                        "string"
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>*/}

                                          {sample.labAquaTestDetail &&
                                            sample.labAquaTestDetail
                                              .filter(
                                                (test) =>
                                                  test.testDescription !== ""
                                              )
                                              .map((test, testIndex) => (
                                                <tr
                                                  key={`test-row-${index}-${testIndex}`}
                                                >
                                                  <td
                                                    className="br-1"
                                                    colSpan={2}
                                                  >
                                                    <div className="mb-3">
                                                      <div className="mb-2">
                                                        <div className="test-detail">
                                                          <div
                                                            id={`testDescription-${index}-${test.labTestID}`}
                                                            className="test-description"
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                test.testDescription,
                                                            }}
                                                          />
                                                          {!(
                                                            amendCase ===
                                                              "CASE4" ||
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          ) && (
                                                            <div
                                                              className="test-remove-icon"
                                                              onClick={() =>
                                                                handleRemoveTest(
                                                                  sample.labAquaTestDetail,
                                                                  test.testDescription,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              <i className="bi bi-dash-circle"></i>
                                                            </div>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td className="fnt-wg tr-ignore">
                                                    <div className="mb-3">
                                                      <div className="mb-2">
                                                        <label
                                                          htmlFor={`repeatCount-${index}-${testIndex}`}
                                                          className="col-form-label float-start"
                                                        >
                                                          Number of Tests
                                                          <span className="star-red">
                                                            *
                                                          </span>
                                                        </label>
                                                        <div className="input-group date">
                                                          <input
                                                            type="number"
                                                            id={`repeatCount-${index}-${testIndex}`}
                                                            min="1"
                                                            className="form-control"
                                                            value={
                                                              repeatCounts[
                                                                index
                                                              ]?.[testIndex] ??
                                                              test.noOfTestsRequired
                                                            }
                                                            disabled={
                                                              amendCase ==
                                                                "CASE4" ||
                                                              isCancelRequest ||
                                                              IsAcknowledgeRequest ||
                                                              IsAcknowledge ||
                                                              IsSubmitresultRequest
                                                            }
                                                            onChange={(e) =>
                                                              handleRepeatCountChange(
                                                                index,
                                                                testIndex,
                                                                Math.min(
                                                                  Number(
                                                                    e.target
                                                                      .value
                                                                  ),
                                                                  1000
                                                                )
                                                              )
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              ))}

                                          {sample.labAquaTestDetail && (
                                            <>
                                              {sample.labAquaTestDetail.some(
                                                (test) =>
                                                  test.testMethodSOPDescription
                                                    ?.trim()
                                                    .toLowerCase() ===
                                                  "post-mortem"
                                              ) && (
                                                <tr>
                                                  <td colSpan={3}>
                                                    <div className="col-lg-12">
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor="flexRadioDefault1"
                                                      >
                                                        <a
                                                          href=""
                                                          className="font-weight-500"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            setShowPostMortem(
                                                              !showPostMortem
                                                            );
                                                          }}
                                                        >
                                                          For Post Mortem:{" "}
                                                          {showPostMortem
                                                            ? "[-]"
                                                            : "[+]"}
                                                        </a>
                                                      </label>

                                                      {showPostMortem && (
                                                        <>
                                                          <div className="row">
                                                            <div className="col-lg-4">
                                                              <label
                                                                htmlFor="postMortemConsentForms"
                                                                className="form-check-label"
                                                                onMouseEnter={
                                                                  handleMouseEnter
                                                                }
                                                                onMouseLeave={
                                                                  handleMouseLeave
                                                                }
                                                                title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                                              >
                                                                Post-Mortem
                                                                Consent Form
                                                                <span className="star-red">
                                                                  *
                                                                </span>
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "5px",
                                                                  }}
                                                                >
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faInfoCircle
                                                                    }
                                                                  />
                                                                </span>
                                                              </label>
                                                              <input
                                                                type="file"
                                                                className="form-control"
                                                                id="postMortemConsentForm"
                                                                multiple
                                                                onChange={(
                                                                  event
                                                                ) =>
                                                                  handlepostmartemFileChange(
                                                                    event,
                                                                    index
                                                                  )
                                                                }
                                                                disabled={
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                              />

                                                              {sample.postMortemConsentFormName &&
                                                                sample
                                                                  .postMortemConsentFormName
                                                                  .length >
                                                                  0 && (
                                                                  <div className="file-view mt-2">
                                                                    {sample.postMortemConsentFormName
                                                                      .split(
                                                                        ", "
                                                                      )
                                                                      .map(
                                                                        (
                                                                          name,
                                                                          fileIndex
                                                                        ) => (
                                                                          <div
                                                                            key={
                                                                              fileIndex
                                                                            }
                                                                            className="file-item d-flex align-items-center"
                                                                          >
                                                                            <div className="file-name">
                                                                              {
                                                                                name
                                                                              }
                                                                            </div>
                                                                            {!(
                                                                              amendCase ===
                                                                                "CASE4" ||
                                                                              isCancelRequest ||
                                                                              IsAcknowledgeRequest ||
                                                                              IsAcknowledge ||
                                                                              IsSubmitresultRequest
                                                                            ) && (
                                                                              <div
                                                                                className="test-remove-icon ml-2"
                                                                                onClick={() =>
                                                                                  handledremoveFile(
                                                                                    name,
                                                                                    index,
                                                                                    fileIndex
                                                                                  )
                                                                                }
                                                                                title="Remove file"
                                                                              >
                                                                                <i className="bi bi-dash-circle"></i>
                                                                              </div>
                                                                            )}
                                                                          </div>
                                                                        )
                                                                      )}
                                                                  </div>
                                                                )}
                                                              {sample?.postMortemConsentFormNameErrMsg && (
                                                                <div className="error-message">
                                                                  <FontAwesomeIcon
                                                                    className="me-1"
                                                                    icon={
                                                                      faCircleExclamation
                                                                    }
                                                                  />
                                                                  Please submit
                                                                  consent form.
                                                                </div>
                                                              )}
                                                            </div>
                                                            <div className="col-lg-4">
                                                              <label className="form-check-label">
                                                                Save Remains for
                                                                Burial/Cremation
                                                                <span className="star-red">
                                                                  *
                                                                </span>
                                                              </label>
                                                              <div className="form-checked">
                                                                <select
                                                                  id="saveRemains"
                                                                  name="saveRemains"
                                                                  className="form-select"
                                                                  value={
                                                                    sample?.saveRemains ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleFormChange(
                                                                      index,
                                                                      "string"
                                                                    )(e);
                                                                  }}
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Select an
                                                                    option
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>
                                                              {sample?.saveRemainsErrMsg && (
                                                                <div className="error-message">
                                                                  <FontAwesomeIcon
                                                                    className="me-1"
                                                                    icon={
                                                                      faCircleExclamation
                                                                    }
                                                                  />
                                                                  Please fill
                                                                  save Remains.
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>

                                                          <div className="row">
                                                            <div className="col-lg-4">
                                                              <label
                                                                className="form-check-label"
                                                                htmlFor="Remarks"
                                                              >
                                                                Remarks
                                                              </label>
                                                              <textarea
                                                                className="form-control"
                                                                name="remarks"
                                                                value={
                                                                  sample?.remarks ||
                                                                  ""
                                                                }
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  handleFormChange(
                                                                    index,
                                                                    "string"
                                                                  )(e);
                                                                }}
                                                                maxLength={500}
                                                                disabled={
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                          <div className="form-check col-lg-12">
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input mt10"
                                                              id="euthanised"
                                                              checked={
                                                                sample?.euthanised
                                                              }
                                                              onChange={(e) =>
                                                                handleEuthanisedChange(
                                                                  e,
                                                                  index
                                                                )
                                                              }
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                            <label
                                                              className="form-check-label"
                                                              htmlFor="euthanised"
                                                            >
                                                              Euthanised
                                                            </label>
                                                          </div>

                                                          {sample?.euthanised && (
                                                            <>
                                                              <div className="col-lg-3">
                                                                <label
                                                                  htmlFor="euthanisedDate"
                                                                  className="form-check-label"
                                                                >
                                                                  Euthanised
                                                                  Date
                                                                </label>
                                                                <input
                                                                  type="date"
                                                                  id="euthanisedDate"
                                                                  name="euthanisedDate"
                                                                  value={
                                                                    sample?.euthanisedDate
                                                                      ? moment(
                                                                          sample?.euthanisedDate
                                                                        ).format(
                                                                          "YYYY-MM-DD"
                                                                        )
                                                                      : ""
                                                                  }
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                  className="form-control"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleFormChange(
                                                                      index,
                                                                      "string"
                                                                    )(e);
                                                                  }}
                                                                  max={maxdate}
                                                                />
                                                              </div>

                                                              <div className="col-lg-3">
                                                                <label
                                                                  htmlFor="methodofEuthanised"
                                                                  className="col-form-label"
                                                                >
                                                                  Method of
                                                                  Euthanasia
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  id="methodofEuthanised"
                                                                  name="methodofEuthanised"
                                                                  value={
                                                                    sample?.methodofEuthanised ||
                                                                    ""
                                                                  }
                                                                  maxLength={
                                                                    100
                                                                  }
                                                                  className="form-control"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    handleFormChange(
                                                                      index,
                                                                      "string"
                                                                    )(e);
                                                                  }}
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                />
                                                              </div>
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                            </>
                                          )}
                                          <div className="col-lg-12">
                                            <label
                                              className="form-check-label"
                                              htmlFor="flexRadioDefault1"
                                            >
                                              <a
                                                href=""
                                                className="font-weight-500"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setShowGroupAnimals(
                                                    !showGroupAnimals
                                                  );
                                                }}
                                              >
                                                For Group Animals:{" "}
                                                {showGroupAnimals
                                                  ? "[-]"
                                                  : "[+]"}
                                              </a>
                                            </label>
                                          </div>

                                          {showGroupAnimals && (
                                            <>
                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        No. on Premises
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          className="form-control"
                                                          value={
                                                            sample?.noOnPremises
                                                          }
                                                          name="noOnPremises"
                                                          onChange={(e) => {
                                                            if (
                                                              e.target.value
                                                                .length <= 10
                                                            ) {
                                                              handleFormChange(
                                                                index,
                                                                "number"
                                                              )(e);
                                                            }
                                                          }}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        No. in Group/Pen
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          className="form-control"
                                                          value={
                                                            sample?.noInGroup
                                                          }
                                                          name="noInGroup"
                                                          onChange={(e) => {
                                                            if (
                                                              e.target.value
                                                                .length <= 10
                                                            ) {
                                                              handleFormChange(
                                                                index,
                                                                "number"
                                                              )(e);
                                                            }
                                                          }}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        No. Sick
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          className="form-control"
                                                          value={sample?.noSick}
                                                          name="noSick"
                                                          onChange={(e) => {
                                                            if (
                                                              e.target.value
                                                                .length <= 10
                                                            ) {
                                                              handleFormChange(
                                                                index,
                                                                "number"
                                                              )(e);
                                                            }
                                                          }}
                                                          maxLength={20}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>

                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        No. at Risk
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          className="form-control"
                                                          value={
                                                            sample?.noAtRisk
                                                          }
                                                          name="noAtRisk"
                                                          onChange={(e) => {
                                                            if (
                                                              e.target.value
                                                                .length <= 10
                                                            ) {
                                                              handleFormChange(
                                                                index,
                                                                "number"
                                                              )(e);
                                                            }
                                                          }}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Herd/Group ID
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            sample?.groupID
                                                          }
                                                          name="groupID"
                                                          maxLength={20}
                                                          onChange={handleFormChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        House/Pen No
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={sample?.penNo}
                                                          name="penNo"
                                                          maxLength={20}
                                                          onChange={handleFormChange(
                                                            index,
                                                            "text"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        No. Dead
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          className="form-control"
                                                          value={sample?.noDead}
                                                          name="noDead"
                                                          onChange={(e) => {
                                                            if (
                                                              e.target.value
                                                                .length <= 10
                                                            ) {
                                                              handleFormChange(
                                                                index,
                                                                "number"
                                                              )(e);
                                                            }
                                                          }}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          )}
                                          <div className="col-lg-12">
                                            <label className="form-check-label">
                                              <a
                                                href="#"
                                                className="font-weight-500"
                                                onClick={
                                                  handleToggleAnimalDetails
                                                }
                                              >
                                                For Individual Animal{" "}
                                                {animalDetails ? "[-]" : "[+]"}
                                              </a>
                                            </label>
                                          </div>
                                          {animalDetails && (
                                            <>
                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Owner
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={sample?.owner}
                                                          name="owner"
                                                          maxLength={100}
                                                          onChange={handleFormChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Name of Animal
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            sample?.nameofAnimal
                                                          }
                                                          maxLength={100}
                                                          name="nameofAnimal"
                                                          onChange={handleFormChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        ID/Microchip No.
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            sample?.microchipNo
                                                          }
                                                          maxLength={40}
                                                          name="microchipNo"
                                                          onChange={handleFormChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Date of Birth
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="date"
                                                          className="form-control"
                                                          value={
                                                            sample?.dateofBirth
                                                              ? moment(
                                                                  sample?.dateofBirth
                                                                ).format(
                                                                  "YYYY-MM-DD"
                                                                )
                                                              : ""
                                                          }
                                                          name="dateofBirth"
                                                          onChange={handleFormChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          max={maxdate}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledge ||
                                                            IsAcknowledgeRequest ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="Sterilized"
                                                        className="col-form-label"
                                                      >
                                                        Sterilized
                                                      </label>

                                                      <select
                                                        className="form-select"
                                                        name="sterilized"
                                                        onChange={handleFormChange(
                                                          index,
                                                          "number"
                                                        )}
                                                        disabled={
                                                          isCancelRequest ||
                                                          IsAcknowledgeRequest ||
                                                          IsAcknowledge ||
                                                          IsSubmitresultRequest
                                                        }
                                                        value={
                                                          sample?.sterilized
                                                        }
                                                        aria-label="Default select example"
                                                      >
                                                        <option selected>
                                                          {" "}
                                                          -- Select --
                                                        </option>

                                                        <option value={1}>
                                                          Yes
                                                        </option>
                                                        <option value={2}>
                                                          {" "}
                                                          No
                                                        </option>
                                                        <option value={3}>
                                                          Unknown
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="countryOfResidence"
                                                        className="col-form-label"
                                                      >
                                                        Country of Residence
                                                      </label>

                                                      <Select
                                                        options={countryOptions}
                                                        styles={customStyles}
                                                        value={countryOptions.find(
                                                          (option) =>
                                                            option.value ===
                                                            sample.countryofResidence
                                                        )}
                                                        onChange={handleSelectChange(
                                                          index,
                                                          "countryofResidence"
                                                        )}
                                                        isDisabled={
                                                          isCancelRequest ||
                                                          IsAcknowledge ||
                                                          IsAcknowledgeRequest ||
                                                          IsSubmitresultRequest
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>

                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="gender"
                                                        className="col-form-label"
                                                      >
                                                        Sex
                                                      </label>
                                                      <div className="input-group">
                                                        <label
                                                          className="form-check-label me-2"
                                                          htmlFor="male"
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`male-${index}`}
                                                            name={`gender-${index}`}
                                                            value="Male"
                                                            disabled={
                                                              isCancelRequest ||
                                                              IsAcknowledge ||
                                                              IsAcknowledgeRequest ||
                                                              IsSubmitresultRequest
                                                            }
                                                            checked={
                                                              sample?.gender ===
                                                              "Male"
                                                            }
                                                            onChange={handleFormChange(
                                                              index,
                                                              "radio"
                                                            )}
                                                            className="form-check-input"
                                                          />
                                                          Male
                                                        </label>

                                                        <label
                                                          className="form-check-label me-2"
                                                          htmlFor="female"
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`female-${index}`}
                                                            name={`gender-${index}`}
                                                            value="Female"
                                                            disabled={
                                                              isCancelRequest ||
                                                              IsAcknowledge ||
                                                              IsAcknowledgeRequest ||
                                                              IsSubmitresultRequest
                                                            }
                                                            checked={
                                                              sample?.gender ===
                                                              "Female"
                                                            }
                                                            onChange={handleFormChange(
                                                              index,
                                                              "radio"
                                                            )}
                                                            className="form-check-input"
                                                          />
                                                          Female
                                                        </label>

                                                        <label
                                                          className="form-check-label"
                                                          htmlFor="unknown"
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`unknown-${index}`}
                                                            name={`gender-${index}`}
                                                            value="unknown"
                                                            disabled={
                                                              isCancelRequest ||
                                                              IsAcknowledge ||
                                                              IsAcknowledgeRequest ||
                                                              IsSubmitresultRequest
                                                            }
                                                            checked={
                                                              sample?.gender ===
                                                              "unknown"
                                                            }
                                                            onChange={handleFormChange(
                                                              index,
                                                              "radio"
                                                            )}
                                                            className="form-check-input"
                                                          />
                                                          Unknown
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td
                                                  className="fnt-wg tr-ignore"
                                                  colSpan={2}
                                                >
                                                  <div className="mb-3">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="age"
                                                        className="col-form-label"
                                                      >
                                                        Age
                                                      </label>
                                                      <div className="input-group">
                                                        <div className="row">
                                                          <div className="col-lg-3">
                                                            <label className="form-label">
                                                              Years
                                                            </label>
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              name="years"
                                                              value={
                                                                sample?.years
                                                              }
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledge ||
                                                                IsAcknowledgeRequest ||
                                                                IsSubmitresultRequest
                                                              }
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <= 3
                                                                ) {
                                                                  handleFormChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              placeholder={
                                                                showPlaceholder
                                                                  ? "yrs"
                                                                  : ""
                                                              }
                                                            />
                                                          </div>
                                                          <div className="col-lg-3">
                                                            <label className="form-label">
                                                              Months
                                                            </label>
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              name="months"
                                                              value={
                                                                sample?.months
                                                              }
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledge ||
                                                                IsAcknowledgeRequest ||
                                                                IsSubmitresultRequest
                                                              }
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <= 3
                                                                ) {
                                                                  handleFormChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              placeholder={
                                                                showPlaceholder
                                                                  ? "mths"
                                                                  : ""
                                                              }
                                                            />
                                                          </div>
                                                          <div className="col-lg-3">
                                                            <label className="form-label">
                                                              Weeks
                                                            </label>
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              name="weeks"
                                                              value={
                                                                sample?.weeks
                                                              }
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledge ||
                                                                IsAcknowledgeRequest ||
                                                                IsSubmitresultRequest
                                                              }
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <= 3
                                                                ) {
                                                                  handleFormChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              placeholder={
                                                                showPlaceholder
                                                                  ? "weeks"
                                                                  : ""
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={3} title="My Preference">
                      <div className="personal-info">
                        <div className="clonable-block">
                          <div className="clonable">
                            <div className="info-content">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        For Bacterial Culture Only
                                      </label>
                                    </div>
                                    <div className="col-lg-7 d-flex align-items-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-2"
                                        name="antimicrobialSusceptibilityTestRequired"
                                        onChange={(e) =>
                                          handleMyPreference(e, "checkbox")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge ||
                                          amendCase === "CASE4"
                                        }
                                        checked={
                                          myPreference?.antimicrobialSusceptibilityTestRequired
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="antimicrobialSusceptibilityTestRequired"
                                      >
                                        Antimicrobial Susceptibility Test
                                        Required
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        Special Instructions/ Additional
                                        Information
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="specialInstructions"
                                        onChange={(e) =>
                                          handleMyPreference(e, "string")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge
                                        }
                                        maxLength={500}
                                        value={
                                          myPreference?.specialInstructions
                                        }
                                      />
                                      <p className="text-muted small mt-1">
                                        {myPreference?.specialInstructions
                                          ?.length || 0}{" "}
                                        / 500 characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row mt-2 mt-lg-0">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="otherRemarks"
                                      >
                                        Other Remarks
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="remarks"
                                        value={myPreference?.remarks}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        maxLength={500}
                                        onChange={(e) =>
                                          handleMyPreference(e, "string")
                                        }
                                      />
                                      <p className="text-muted small mt-1">
                                        {myPreference?.remarks?.length || 0} /
                                        500 characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        htmlFor="supportDocuments"
                                        className="form-check-label"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                      >
                                        Support Documents
                                        <span style={{ marginLeft: "5px" }}>
                                          <FontAwesomeIcon
                                            icon={faInfoCircle}
                                          />
                                        </span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="SupportDocuments"
                                        multiple
                                        onChange={handledFileChange}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                      {myPreference?.supportDocumentName && (
                                        <div className="file-view mt-2">
                                          {myPreference.supportDocumentName
                                            .split(", ")
                                            .map((name, index) => (
                                              <div
                                                key={index}
                                                className="file-item d-flex align-items-center"
                                              >
                                                <div className="file-name">
                                                  {name}
                                                </div>
                                                {!(
                                                  amendCase === "CASE4" ||
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                ) && (
                                                  <div
                                                    className="test-remove-icon ml-2"
                                                    onClick={() =>
                                                      handleRemoveFile(name)
                                                    }
                                                    title="Remove file"
                                                  >
                                                    <i className="bi bi-dash-circle"></i>
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="modeOfReceiving"
                                      >
                                        Mode of receiving report
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <select
                                        name="modeOfReceiving"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={myPreference?.modeOfReceiving}
                                        onChange={(e) => {
                                          handleMyPreference(e, "number");

                                          const value = Number(e.target.value);

                                          if (value === 1 || value === 3) {
                                            setMyPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "Yes",
                                            }));
                                          } else {
                                            setMyPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "No",
                                            }));
                                          }
                                        }}
                                        className="form-select"
                                        aria-label="Mode of receiving report"
                                      >
                                        <option value="" selected>
                                          Select an option
                                        </option>
                                        <option value={2}>Email</option>
                                      </select>

                                      {myPreference?.modeOfReceivingErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please select Mode of Report.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {myPreference?.modeOfReceiving === 1 && (
                                  <div className="row mt-2">
                                    <div className="col-lg-6">
                                      <label className="form-check-label fw-bold mb-2">
                                        Please select the address for mailing:
                                      </label>
                                      <select
                                        name="mailingAddress"
                                        className="form-select mb-3"
                                        value={myPreference?.mailingAddress}
                                        onChange={(e) =>
                                          handleMyPreference(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      >
                                        <option value="" selected>
                                          Please Select address
                                        </option>
                                        <option value={1}>
                                          Same as mailing address
                                        </option>
                                        <option value={2}>
                                          Same as billing address
                                        </option>
                                        <option value={3}>
                                          Others (please specify)
                                        </option>
                                      </select>
                                      {myPreference?.mailingAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please Select the address
                                        </div>
                                      )}

                                      {myPreference?.mailingAddress === 3 && (
                                        <div className="col-lg-12">
                                          <textarea
                                            className="form-control mt-2"
                                            placeholder="Enter address"
                                            name="customAddress"
                                            value={
                                              myPreference?.customAddress || ""
                                            }
                                            onChange={(e) =>
                                              handleMyPreference(e, "string")
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                      )}
                                      {myPreference?.customAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please enter address
                                        </div>
                                      )}

                                      <div className="alert alert-warning mt-3">
                                        Please note that NParks is not liable
                                        for lost mail, and any additional copies
                                        of laboratory reports are subject to
                                        additional charges.
                                      </div>

                                      <div className="form-check mt-3">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mt-2"
                                          id="acknowledgeCheckbox"
                                          name="acknowledge"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          checked={
                                            myPreference?.acknowledge || false
                                          }
                                          onChange={(e) =>
                                            handleMyPreference(e, "checkbox")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="acknowledgeCheckbox"
                                        >
                                          I acknowledge the above information
                                        </label>
                                      </div>

                                      {myPreference?.acknowledgeErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          You must acknowledge before proceeding
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  )}
                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <Tab eventKey={4} title="Results">
                      {pageLoader || checkpageLoader ? (
                        <Loader />
                      ) : (
                        samples &&
                        samples
                          .filter((sample) => {
                            return sample.labAquaTestDetail.some(
                              (test: any) => {
                                const isValidTest =
                                  test.isThirdPartyLab === 1 &&
                                  test.thirdPartyNric === customerNRIC &&
                                  test.rowId === testRowId &&
                                  (test.testStatus === null ||
                                    test.testStatus !== 8);

                                return isValidTest;
                              }
                            );
                          })
                          .map(
                            (
                              sample: IAquaSamplesAndTests,
                              sampleIndex: number
                            ) => {
                              return (
                                <div
                                  className="personal-info"
                                  key={sampleIndex}
                                >
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={sampleIndex + 1}
                                    >
                                      <div className="info-heading">
                                        <h2 className="pb-0">
                                          Serial number {sampleIndex + 1}
                                        </h2>
                                      </div>

                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2">
                                          <table className="table table-striped product_table start_table">
                                            <thead> </thead>

                                            <tbody>
                                              <div>
                                                {sample.labAquaTestDetail &&
                                                  sample.labAquaTestDetail
                                                    .filter((test: any) => {
                                                      const isValidTest =
                                                        test.isThirdPartyLab ===
                                                          1 &&
                                                        test.thirdPartyNric ===
                                                          customerNRIC &&
                                                        (test.testStatus ===
                                                          null ||
                                                          test.testStatus !==
                                                            8) &&
                                                        test.rowId ===
                                                          testRowId;

                                                      return isValidTest;
                                                    })
                                                    .map((test, testIndex) => (
                                                      <tr
                                                        key={`test-row-${sampleIndex}-${test.labTestID}`}
                                                      >
                                                        <td className="br-1">
                                                          <div className="mb-3">
                                                            <div className="mb-2">
                                                              <div className="heading-test">
                                                                <h2 className="pb-0">
                                                                  {
                                                                    <div
                                                                      id={`testDescription-${sampleIndex}-${test.labTestID}`}
                                                                      className="test-description"
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          test.testDescription,
                                                                      }}
                                                                    />
                                                                  }
                                                                </h2>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className="info-content">
                                                            <div className="table table-striped product_table start_table">
                                                              <div className="d-flex flex-row justify-content-between align-items-center">
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center mt-2 mt-lg-0">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        className="form-check-label"
                                                                        htmlFor="sampleMarking"
                                                                      >
                                                                        Sample
                                                                        Marking
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={
                                                                          sample?.sampleMarking
                                                                        }
                                                                        name="sampleMarking"
                                                                        disabled
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        htmlFor="supportDocuments"
                                                                        className="form-check-label"
                                                                        onMouseEnter={
                                                                          handleMouseEnter
                                                                        }
                                                                        onMouseLeave={
                                                                          handleMouseLeave
                                                                        }
                                                                        title="Documents allowed:pdf,docx,doc,jpg,jpeg,png,xlsx,xls."
                                                                      >
                                                                        Result
                                                                        Documents
                                                                        <span
                                                                          style={{
                                                                            marginLeft:
                                                                              "5px",
                                                                          }}
                                                                        >
                                                                          <FontAwesomeIcon
                                                                            icon={
                                                                              faInfoCircle
                                                                            }
                                                                          />
                                                                        </span>
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        id="ResultDocuments"
                                                                        disabled={
                                                                          amendCase ===
                                                                            "CASE4" ||
                                                                          isCancelRequest ||
                                                                          IsAcknowledgeRequest ||
                                                                          IsAcknowledge
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handledFiledChange(
                                                                            sampleIndex,
                                                                            test.labTestID ??
                                                                              "",

                                                                            e
                                                                          )
                                                                        }
                                                                        multiple
                                                                      />

                                                                      {test?.ResultDocumentName ? (
                                                                        <div className="file-view">
                                                                          {
                                                                            test?.ResultDocumentName
                                                                          }
                                                                        </div>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div className="row">
                                                              {(test.labAquaTestResult &&
                                                              test
                                                                .labAquaTestResult
                                                                .length > 0
                                                                ? test.labAquaTestResult
                                                                : [
                                                                    defaultTestResult,
                                                                  ]
                                                              ).map(
                                                                (
                                                                  result,
                                                                  resultIndex
                                                                ) => (
                                                                  <div
                                                                    className="row mt-2"
                                                                    key={`result-${test.labTestID}-${resultIndex}`}
                                                                  >
                                                                    {IsSubmitresultRequest && (
                                                                      <div className="info-heading">
                                                                        <ul className="card-icons float-end">
                                                                          <li>
                                                                            <button
                                                                              className="icon-button"
                                                                              title="New"
                                                                              onClick={() =>
                                                                                handleAddTestResult(
                                                                                  sampleIndex,
                                                                                  test.labTestID ??
                                                                                    ""
                                                                                )
                                                                              }
                                                                            >
                                                                              <FontAwesomeIcon
                                                                                icon={
                                                                                  faPlus
                                                                                }
                                                                              />
                                                                            </button>
                                                                          </li>
                                                                          <li className="copy-button-container">
                                                                            <button
                                                                              className="icon-button"
                                                                              title="Copy"
                                                                              onClick={() =>
                                                                                handledCopyButtonClick(
                                                                                  sampleIndex,
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )
                                                                              }
                                                                            >
                                                                              <FontAwesomeIcon
                                                                                icon={
                                                                                  faCopy
                                                                                }
                                                                              />
                                                                            </button>
                                                                          </li>

                                                                          {resultIndex !==
                                                                            0 && (
                                                                            <li>
                                                                              <button
                                                                                className="icon-button"
                                                                                onClick={() =>
                                                                                  handleDeleteTestResult(
                                                                                    sampleIndex,
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )
                                                                                }
                                                                                title="Delete"
                                                                              >
                                                                                <FontAwesomeIcon
                                                                                  icon={
                                                                                    faTrashCan
                                                                                  }
                                                                                />
                                                                              </button>
                                                                            </li>
                                                                          )}
                                                                        </ul>
                                                                        <h2 className="labresults-heading">
                                                                          {resultIndex ===
                                                                          0
                                                                            ? "Test Result"
                                                                            : `Additional Result ${resultIndex}`}
                                                                        </h2>
                                                                      </div>
                                                                    )}

                                                                    <>
                                                                      {test.isPostMartem ===
                                                                        0 && (
                                                                        <>
                                                                          <div className="row align-items-center">
                                                                            <div className="col-lg-6">
                                                                              <label
                                                                                className="form-check-label"
                                                                                htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                              >
                                                                                Result
                                                                                Code
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <Select
                                                                                options={
                                                                                  ResultCodeOptions
                                                                                }
                                                                                value={
                                                                                  ResultCodeOptions.find(
                                                                                    (
                                                                                      option
                                                                                    ) =>
                                                                                      option.value ===
                                                                                      result.resultcode
                                                                                  ) ||
                                                                                  null
                                                                                }
                                                                                styles={
                                                                                  customedStyles
                                                                                }
                                                                                isDisabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSelectChange(
                                                                                  sampleIndex,
                                                                                  "resultcode",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                              {result?.resultcodeErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Result
                                                                                  Code.
                                                                                </div>
                                                                              )}
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Units
                                                                              </label>
                                                                              <textarea
                                                                                id="units"
                                                                                className="form-control"
                                                                                name="units"
                                                                                value={
                                                                                  result?.units ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Testing
                                                                                Instructions
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <textarea
                                                                                id="testingInstruction"
                                                                                className="form-control"
                                                                                name="testingInstructions"
                                                                                value={
                                                                                  result?.testingInstructions ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />

                                                                              {result?.testingInstructionsErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Testing
                                                                                  Instructions.
                                                                                </div>
                                                                              )}
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Remarks
                                                                                for
                                                                                Third
                                                                                Party
                                                                                Laboratory
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <textarea
                                                                                id="remarksForThirdParty"
                                                                                className="form-control"
                                                                                name="remarksForThirdParty"
                                                                                value={
                                                                                  result?.remarksForThirdParty ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                              {result?.remarksForThirdPartyErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Remarks
                                                                                  for
                                                                                  Third
                                                                                  Party
                                                                                  Laboratory.
                                                                                </div>
                                                                              )}
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Symbol
                                                                                1
                                                                              </label>
                                                                              <select
                                                                                className="form-select"
                                                                                name="Symbol1"
                                                                                value={
                                                                                  result?.Symbol1 ||
                                                                                  ""
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "number",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              >
                                                                                <option value="">
                                                                                  Select
                                                                                </option>
                                                                                <option value="1">
                                                                                  &lt;
                                                                                </option>
                                                                                <option value="2">
                                                                                  &gt;
                                                                                </option>
                                                                                <option value="3">
                                                                                  +
                                                                                </option>
                                                                                <option value="4">
                                                                                  -
                                                                                </option>
                                                                              </select>
                                                                            </div>
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Readings
                                                                                1
                                                                              </label>
                                                                              <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="Readings"
                                                                                step="0.01"
                                                                                disabled={
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                value={
                                                                                  result?.Readings ||
                                                                                  0
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "decimal",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Symbol
                                                                                2
                                                                              </label>
                                                                              <select
                                                                                className="form-select"
                                                                                name="Symbol2"
                                                                                value={
                                                                                  result?.Symbol2 ||
                                                                                  ""
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "number",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              >
                                                                                <option value="">
                                                                                  Select
                                                                                </option>
                                                                                <option value="1">
                                                                                  E
                                                                                </option>
                                                                                <option value="2">
                                                                                  /
                                                                                </option>
                                                                              </select>
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Reading
                                                                                2
                                                                              </label>
                                                                              <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="Readings2"
                                                                                step="0.01"
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                value={
                                                                                  result?.Readings2 ||
                                                                                  0
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "decimal",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Positive">
                                                                                Positive
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                id="Positive"
                                                                                className="form-control"
                                                                                name="Positive"
                                                                                value={
                                                                                  result?.Positive ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Negative">
                                                                                Negative
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Negative"
                                                                                value={
                                                                                  result?.Negative ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Indefinite">
                                                                                Indefinite
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                id="Indefinite"
                                                                                className="form-control"
                                                                                name="Indefinite"
                                                                                value={
                                                                                  result?.Indefinite ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="ResultRemarks">
                                                                                Remarks
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="ResultRemarks"
                                                                                value={
                                                                                  result?.ResultRemarks ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </>
                                                                    <>
                                                                      {test.isPostMartem ===
                                                                        1 && (
                                                                        <>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                                  >
                                                                                    Result
                                                                                    Code
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <Select
                                                                                    options={
                                                                                      ResultCodeOptions
                                                                                    }
                                                                                    value={
                                                                                      ResultCodeOptions.find(
                                                                                        (
                                                                                          option
                                                                                        ) =>
                                                                                          option.value ===
                                                                                          result.resultcode
                                                                                      ) ||
                                                                                      null
                                                                                    }
                                                                                    styles={
                                                                                      customedStyles
                                                                                    }
                                                                                    isDisabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSelectChange(
                                                                                      sampleIndex,
                                                                                      "resultcode",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                  {result?.resultcodeErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Result
                                                                                      Code
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`units-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Units
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="units"
                                                                                    value={
                                                                                      result?.units ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`testingInstructions-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Testing
                                                                                    Instructions
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="testingInstructions"
                                                                                    value={
                                                                                      result?.testingInstructions ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                  {result?.testingInstructionsErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Testing
                                                                                      Instructions.
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Parasitology"
                                                                                  >
                                                                                    Remarks
                                                                                    for
                                                                                    Third
                                                                                    Party
                                                                                    Laboratory{" "}
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="remarksForThirdParty"
                                                                                    value={
                                                                                      result?.remarksForThirdParty ||
                                                                                      ""
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />

                                                                                  {result?.remarksForThirdPartyErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Remarks
                                                                                      for
                                                                                      Third
                                                                                      Party
                                                                                      Laboratory.
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`report-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Report
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="report"
                                                                                    value={
                                                                                      result?.report ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Parasitology"
                                                                                  >
                                                                                    Parasitology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Parasitology"
                                                                                    value={
                                                                                      result?.Parasitology ||
                                                                                      ""
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Microbiology"
                                                                                  >
                                                                                    Microbiology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Microbiology"
                                                                                    value={
                                                                                      result?.Microbiology ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Histopathology"
                                                                                  >
                                                                                    Histopathology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Histopathology"
                                                                                    value={
                                                                                      result?.Histopathology ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="ourreference"
                                                                                  >
                                                                                    Our
                                                                                    Reference
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="ourreference"
                                                                                    value={
                                                                                      result?.ourreference ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="finalDiagnosis"
                                                                                  >
                                                                                    Final
                                                                                    Diagnosis
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="finalDiagnosis"
                                                                                    value={
                                                                                      result?.finalDiagnosis ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                    disabled={
                                                                                      amendCase ===
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ))}
                                              </div>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )
                      )}
                    </Tab>
                  )}
                </Tabs>

                {showAmendmentHistory && amendmentHistory?.length > 0 && (
                  <AmendmentGrid
                    data={amendmentHistory}
                    setData={setAmendmentHistory}
                    isLoading
                  />
                )}

                <div className="text-end mt-3 mb-3">
                  {!IsSubmitresultRequest && !IsAcknowledge ? (
                    <button
                      className="btn btn-d btn-secondary px-4"
                      onClick={handlePreviousClick}
                    >
                      Previous
                    </button>
                  ) : null}

                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <>
                      <button
                        className="btn btn-d btn-secondary px-4"
                        onClick={handledPreviousClick}
                      >
                        Previous
                      </button>

                      <button
                        className="btn btn-d btn-primary px-4"
                        onClick={
                          IsSubmitresultRequest
                            ? handledSaveResultClick
                            : handleACKResultClick
                        }
                      >
                        {IsSubmitresultRequest ? "Submit" : "Acknowledge"}
                      </button>
                    </>
                  )}

                  {!IsAcknowledgeRequest &&
                    !IsAcknowledge &&
                    !IsSubmitresultRequest &&
                    !isCancelRequest && (
                      <>
                        {actionType !== TypeOfApplicationEnum.amendment && (
                          <button
                            className="btn btn-d btn-secondry  px-4"
                            onClick={handleSaveDraft}
                            disabled={btnNameForLoader === "submit-req"}
                          >
                            {btnNameForLoader === "submit-req"
                              ? "Submitting..."
                              : "Save Draft"}
                          </button>
                        )}
                        <button
                          className="btn btn-d btn-primary nextBtn"
                          name="next-click"
                          type="button"
                          onClick={validateForm}
                        >
                          Next
                          {btnNameForLoader == "next-click" ? (
                            <Spinner
                              className="btn-spinner"
                              animation="border"
                              variant="light"
                            />
                          ) : (
                            ""
                          )}
                        </button>
                      </>
                    )}
                  {!IsAcknowledgeRequest &&
                    !IsSubmitresultRequest &&
                    !IsAcknowledge &&
                    !cancelButtonHidden &&
                    isCancelRequest && (
                      <button
                        className="btn btn-d btn-primary nextBtn"
                        name="cancel-request-btn"
                        type="button"
                        onClick={cancelRequest}
                        disabled={btnNameForLoader === "cancel-request-btn"}
                      >
                        Cancel Request
                        {btnNameForLoader == "cancel-request-btn" ? (
                          <Spinner
                            className="btn-spinner"
                            animation="border"
                            variant="light"
                          />
                        ) : (
                          ""
                        )}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
      {amendCase === "CASE4" ||
      IsAcknowledgeRequest ||
      IsSubmitresultRequest ||
      IsAcknowledge ||
      isCancelRequest ? (
        ""
      ) : (
        <Modal
          className="popup-2"
          show={showSearchTestsModal}
          onHide={handleCloseSearchTestsModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Tests</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleFormSubmit}>
              <h3>Search for Other Tests</h3>
              <div className="tests-cnt pb-2">
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Laboratory
                    <span className="star-red">*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      className="form-select"
                      aria-label="Test Laboratory"
                      value={selectedTestLaboratory}
                      onChange={(e) => {
                        setSelectedTestLaboratory(e.target.value);
                      }}
                    >
                      <option value="All-laboratories">All laboratories</option>
                      {labtestoptions.map((item, index) => (
                        <option key={index} value={item.labGroup}>
                          {item.labGroup}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-1 row"></div>
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="flexCheckDesc"
                      placeholder=""
                      autoComplete="off"
                      value={testDescription}
                      required
                      onChange={(e) => setTestDescription(e.target.value)}
                      disabled={
                        amendCase === "CASE4" ||
                        isCancelRequest ||
                        IsAcknowledgeRequest ||
                        IsAcknowledge ||
                        IsSubmitresultRequest
                      }
                      className={`form-control ${
                        !testDescription ? "border-danger op05" : ""
                      }`}
                    />
                    <br />

                    <Button
                      variant="primary"
                      className="float-end"
                      name="submit-reqq"
                      disabled={searchLoading}
                      onClick={handleSearch}
                    >
                      Search
                      {btnNameForLoader === "submit-reqq" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </Button>
                  </div>
                </div>
              </div>
              <h3>Examination/Diagnostic Tests</h3>
              <div
                className="tests-cnt"
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  display: "block",
                }}
              >
                <h4>Examination/Diagnostic Tests</h4>

                {testOptions
                  .slice()
                  .sort((a, b) => {
                    const stripHtml = (text: any) =>
                      text.replace(/<[^>]*>/g, "").trim();
                    return stripHtml(a.description).localeCompare(
                      stripHtml(b.description)
                    );
                  })
                  .map((test, index) => (
                    <div className="form-check" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={test.description}
                        id={`testOption${index}`}
                        checked={test.isSelected}
                        onChange={(e) =>
                          toggleTestSelection(
                            test.labCodeMasterID,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`testOption${index}`}
                        dangerouslySetInnerHTML={{ __html: test.description }}
                      ></label>
                    </div>
                  ))}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSearchTestsModal}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleAddTests();
                handleCloseSearchTestsModal();
              }}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Footer />
    </>
  );
};

export default CAVSAquaSamplesAndTests;
